{
  "_meta.name": "العربية",
  "_meta.dir": "rtl",
  "app.title": "CenterOS Agent V2",
  "boot.loading": "جارٍ تسجيل الدخول…",
  "boot.failed": "تعذّر تسجيل الدخول",
  "nav.agents": "وكلاء الذكاء الاصطناعي",
  "nav.studio": "الاستوديو",
  "nav.assets": "الأصول",
  "nav.tests": "الاختبارات وبطاقة التقييم",
  "nav.conversations": "المحادثات",
  "nav.telephony": "أرقام الهاتف",
  "nav.usage": "الاستخدام",
  "nav.soon": "قريبًا",
  "agents.title": "وكلاء الذكاء الاصطناعي",
  "agents.empty": "لا يوجد وكلاء بعد. أنشئ وكيلك الأول باستخدام الاستوديو.",
  "agents.new": "وكيل جديد بالذكاء الاصطناعي",
  "agents.col.name": "الوكيل",
  "agents.col.direction": "الاتجاه",
  "agents.col.status": "الحالة",
  "direction.outbound": "صادرة",
  "direction.inbound": "واردة",
  "direction.both": "واردة + صادرة",
  "status.draft": "مسودة",
  "status.published": "منشور",
  "status.archived": "مؤرشف",
  "studio.title": "الاستوديو",
  "studio.subtitle": "أنشئ وكيلك من خلال المحادثة. Business Brain الخاص بك جاهز.",
  "studio.start": "بدء جلسة جديدة",
  "studio.starting": "جارٍ قراءة Business Brain…",
  "studio.placeholder": "اكتب إجابتك…",
  "studio.send": "إرسال",
  "studio.thinking": "جارٍ التفكير…",
  "studio.draft": "مسودة",
  "studio.missing": "ناقص",
  "studio.filled": "مكتمل",
  "studio.progress": "{done}/{total} حقول",
  "studio.propose": "مراجعة المسودة",
  "studio.approve": "الموافقة وإنشاء الوكيل",
  "studio.approved": "تم إنشاء الوكيل. الخطوة التالية: أصول المبيعات.",
  "studio.review": "المراجعة",
  "error.generic": "حدث خطأ ما",
  "error.UNAUTHENTICATED": "انتهت صلاحية الجلسة، يُرجى تسجيل الدخول مجددًا.",
  "error.HOST_IDENTITY_MISSING": "حسابك في Panaryus غير مرتبط بمساحة العمل هذه.",
  "error.BRAIN_NOT_FOUND": "لم يتم العثور على قاعدة معرفة منشورة للنشاط.",
  "error.STUDIO_INCOMPLETE": "أكمل الحقول الناقصة أولًا.",
  "error.STUDIO_LLM_BAD_OUTPUT": "تعذّر على المساعد الرد، حاول مرة أخرى.",
  "error.STUDIO_INVALID_VALUES": "بعض القيم غير واضحة، هل يمكنك التوضيح أكثر؟",
  "field.identity.name": "اسم الوكيل",
  "field.identity.brandName": "العلامة التجارية",
  "field.identity.persona": "الشخصية",
  "field.languages.primary": "اللغة",
  "field.direction": "اتجاه المكالمة",
  "field.mission.goal": "هدف المكالمة",
  "field.mission.successCondition": "معيار النجاح",
  "field.mission.audience": "الجمهور المستهدف",
  "field.facts": "المعلومات المطلوب جمعها",
  "field.style.tone": "النبرة",
  "field.compliance.require[recording_notice].instruction": "إشعار التسجيل",
  "field.compliance.require[ai_disclosure].instruction": "الإفصاح عن الذكاء الاصطناعي",
  "field.globalIntents[opt_out].description": "طلب الإضافة إلى قائمة عدم الاتصال",
  "agent.back": "← الوكلاء",
  "agent.tab.assets": "الأصول",
  "agent.kit.none": "لا توجد حزمة مبيعات لهذا الوكيل بعد.",
  "agent.kit.build": "إنشاء حزمة المبيعات",
  "agent.kit.rebuild": "إعادة إنشاء الحزمة",
  "agent.kit.building": "جارٍ تجهيز الحزمة… (نحو دقيقة)",
  "agent.kit.failed": "تعذّر إنشاء الحزمة",
  "agent.kit.version": "الإصدار {v} · {lang}",
  "agent.kit.report": "تم إنشاء {generated} عبارة · إصلاح {repaired} · حذف {dropped}",
  "kit.angles": "زوايا القيمة",
  "kit.angles.hint": "عروض جاهزة للتواصل مع العميل من زوايا مختلفة",
  "kit.pitch": "العرض",
  "kit.proof": "الدليل",
  "kit.question": "السؤال",
  "kit.objections": "بطاقات الاعتراضات",
  "kit.objection.back": "سؤال الرد",
  "kit.discovery": "أسئلة الاستكشاف",
  "kit.closings": "خطوات الإغلاق",
  "kit.bridges": "عبارات انتقالية",
  "kit.fallbacks": "عبارات احتياطية",
  "kit.fallback.silence": "عند الصمت",
  "kit.fallback.notUnderstood": "عند عدم الفهم",
  "kit.fallback.technical": "عند حدوث مشكلة تقنية",
  "license.licensed": "موثّق بالمعرفة",
  "license.not_required": "لا يتضمن ادعاءً",
  "license.conversational": "عبارة حوارية",
  "edit": "تعديل",
  "save": "حفظ",
  "cancel": "إلغاء",
  "saving": "جارٍ التحقق…",
  "error.KIT_LINE_UNLICENSED": "تعذّر التحقق من هذه العبارة بالمعلومات الموجودة في Business Brain. لإضافة معلومة جديدة، أضفها إلى Business Brain أولًا.",
  "reason.UNSUPPORTED_NUMBER": "الرقم الوارد فيها غير موجود في Business Brain.",
  "reason.UNSUPPORTED_CLAIM": "تتضمن ادعاءً عن النشاط التجاري غير موجود في Business Brain.",
  "reason.BRIDGE_HAS_CLAIM": "لا يمكن أن تتضمن العبارات الانتقالية معلومات.",
  "error.AGENT_NOT_FOUND": "لم يتم العثور على الوكيل.",
  "error.KIT_INSUFFICIENT_ANGLES": "لا توجد زوايا قيمة موثّقة كافية. أضف معلومات عن المنتجات/الخدمات إلى Business Brain ثم حاول مجددًا.",
  "error.JOB_INTERRUPTED": "توقفت العملية قبل اكتمالها، يُرجى المحاولة مجددًا.",
  "agent.tab.preview": "معاينة",
  "preview.hint": "جرّب الوكيل عبر المحادثة الكتابية. اكتب بصفتك العميل، وسيرد الوكيل كما لو كان على الهاتف. لن يرن أي هاتف.",
  "preview.start": "بدء المعاينة",
  "preview.restart": "إعادة البدء",
  "preview.ended": "أنهى الوكيل المكالمة.",
  "preview.turn": "هذه الجولة",
  "preview.angle": "الزاوية",
  "preview.move": "الخطوة",
  "preview.mood": "العميل",
  "preview.facts": "المعلومات المجمّعة",
  "preview.angles": "الزوايا المجرّبة",
  "preview.critics": "المدقّقون",
  "preview.ms": "المدة",
  "preview.bridge": "عبارة انتقالية",
  "preview.none": "—",
  "preview.needKit": "أنشئ حزمة المبيعات أولًا لبدء المعاينة.",
  "error.AGENT_NOT_READY": "أنشئ حزمة المبيعات أولًا لبدء المعاينة.",
  "error.PREVIEW_NOT_FOUND": "انتهت صلاحية المعاينة، أعد تشغيلها.",
  "agent.tab.tests": "الاختبارات وبطاقة التقييم",
  "score.hint": "يتحدث الوكيل، دون هاتف، مع عملاء افتراضيين: متعجلين، وفظّين، ومتشككين، ورافضين، ومرتبكين، وراضين عن منافس؛ ويتم تقييم كل محادثة. لا يمكن نشر الوكيل قبل اجتياز بطاقة التقييم.",
  "score.run": "تشغيل بطاقة التقييم",
  "score.running": "جارٍ تشغيل بطاقة التقييم… (بضع دقائق)",
  "score.none": "لا توجد بطاقة تقييم بعد.",
  "score.pass": "اجتاز الحد المطلوب",
  "score.fail": "لم يجتز",
  "score.failures": "دون الحد المطلوب",
  "metric.naturalness": "الطبيعية",
  "metric.intent": "فهم النية",
  "metric.respect": "الاحترام",
  "metric.persuasion": "الإقناع",
  "metric.questionRate": "معدل الأسئلة",
  "metric.factCoverage": "المعلومات المجمّعة",
  "metric.nextStepRate": "الخطوة التالية",
  "metric.repeats": "التكرار",
  "metric.silentTurns": "جولات صامتة",
  "metric.identityRepeats": "تكرار التعريف بالهوية",
  "statements.title": "إجابات النشاط التجاري",
  "statements.hint": "إجابات نشاطك التجاري على الأسئلة التي يطرحها العملاء كثيرًا. يستخدمها الوكيل عند إثارة الموضوع؛ وما تكتبه هنا يُعدّ معلومات موثّقة.",
  "statements.contactSource": "الإجابة عن سؤال \"من أين حصلتم على رقمي؟\"",
  "statements.contactSource.placeholder": "مثال: تم الحصول على بيانات الاتصال الخاصة بك من دليل أعمال عام.",
  "statements.topic": "الموضوع (مثل: الأسعار)",
  "statements.answer": "الإجابة",
  "statements.add": "إضافة إجابة",
  "statements.remove": "حذف",
  "statements.saved": "تم الحفظ",
  "error.CONTACT_SOURCE_STATEMENT_REQUIRED": "الوكلاء الذين يُجرون مكالمات صادرة يحتاجون إلى إجابة عن سؤال \"من أين حصلتم على رقمي؟\".",
  "error.SPEC_INVALID": "الإجابات غير صالحة (ربما تكرر الموضوع نفسه مرتين).",
  "humor.title": "الأسلوب في الأسئلة غير المعروفة",
  "humor.hint": "عندما لا يعرف الوكيل إجابة سؤال ما، يقول ذلك بصدق ثم يواصل المكالمة. ومع تفعيل الدعابة الخفيفة، يفعل ذلك بلمسة لطيفة ودافئة.",
  "humor.light": "دعابة خفيفة (موصى بها)",
  "humor.off": "بدون دعابة، أسلوب بسيط",
  "kit.plain": "شروحات مبسّطة",
  "kit.plain.hint": "شروحات قصيرة خالية من المصطلحات التقنية يستخدمها الوكيل عندما لا يفهم العميل.",
  "agent.publish": "نشر",
  "agent.publish.running": "جارٍ النشر…",
  "agent.publish.hint": "تُحفظ الإعدادات الحالية وحزمة المبيعات كإصدار ثابت لا يتغير؛ ولا تستخدم المكالمات الفعلية إلا الإصدار المنشور.",
  "agent.publish.version": "الإصدار المنشور",
  "agent.publish.done": "تم النشر (الإصدار {{id}}). تستخدم المكالمات الفعلية هذا الإصدار الآن.",
  "error.KIT_MISSING_FOR_LANGUAGE": "يلزم وجود حزمة مبيعات لكل لغة قبل النشر.",
  "error.AGENT_NOT_PUBLISHED": "لم يتم نشر الوكيل بعد.",
  "calls.title": "المكالمات · استمع وتابع",
  "calls.subtitle": "المكالمات التي أجراها وكلاؤك، مع التسجيلات والنتائج.",
  "calls.tab.all": "كل المكالمات",
  "calls.tab.callbacks": "معاودة الاتصال",
  "calls.tab.dnc": "قائمة عدم الاتصال",
  "calls.col.date": "التاريخ",
  "calls.col.number": "الرقم",
  "calls.col.agent": "الوكيل",
  "calls.col.duration": "المدة",
  "calls.col.result": "النتيجة",
  "calls.col.callbackWhen": "الموعد",
  "calls.col.note": "ملاحظة",
  "calls.empty": "لا توجد مكالمات بعد. ابدأ المكالمة الأولى عبر زر “اتصال” في صفحة أحد الوكلاء.",
  "calls.callbacks.empty": "لا توجد طلبات معاودة اتصال معلّقة.",
  "calls.callbacks.done": "تم",
  "calls.hasRecording": "التسجيل متاح",
  "calls.result.machine": "بريد صوتي",
  "calls.result.optedOut": "طلب عدم الاتصال به",
  "calls.result.callback": "معاودة الاتصال: {when}",
  "calls.result.live": "جارية",
  "calls.result.notAnswered": "لم يتم الرد",
  "calls.result.error": "خطأ تقني",
  "calls.result.talked": "تمت المحادثة",
  "calls.back": "المحادثات",
  "calls.recording": "التسجيل",
  "calls.noRecording": "لا يوجد تسجيل لهذه المكالمة.",
  "calls.recordingTruncated": "تم اختصار التسجيل بسبب الحد الأقصى للمدة.",
  "calls.transcript": "نص المكالمة",
  "calls.noTurns": "لا يوجد نص للمكالمة.",
  "calls.event.silent": "ظلّ العميل صامتًا",
  "calls.callback": "معاودة الاتصال",
  "calls.callback.open": "لم يتم الاتصال بعد",
  "calls.callback.doneAt": "تم الاتصال: {at}",
  "calls.facts": "المعلومات التي تم جمعها",
  "calls.noFacts": "لم يتم جمع أي معلومات.",
  "dnc.hint": "لن يتصل أي وكيل بهذه الأرقام. عندما يقول العميل “لا تتصلوا بي”، يُضاف رقمه هنا تلقائيًا.",
  "dnc.placeholder": "+1 555 000 0000",
  "dnc.add": "إضافة إلى القائمة",
  "dnc.remove": "حذف",
  "dnc.empty": "القائمة فارغة.",
  "dnc.col.reason": "السبب",
  "dnc.reason.opt_out": "بطلب من العميل",
  "dnc.reason.manual": "أُضيف يدويًا",
  "call.start": "اتصال",
  "call.placeholder": "اكتب رقماً أو اسماً أو شركة",
  "call.next": "متابعة",
  "call.confirm": "سيتم الاتصال بالرقم {phone} الآن. تُحتسب المكالمة بالدقيقة. هل تؤكد؟",
  "call.yes": "نعم، اتصل",
  "call.dialing": "جارٍ الاتصال…",
  "call.started": "بدأت المكالمة.",
  "call.openCall": "فتح المكالمة",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.cancel": "إلغاء",
  "common.back": "رجوع",
  "error.CALL_NOT_FOUND": "المكالمة غير موجودة.",
  "error.RECORDING_NOT_FOUND": "التسجيل غير موجود.",
  "error.CALLBACK_NOT_FOUND": "لا توجد معاودة اتصال مفتوحة لهذه المكالمة.",
  "error.PHONE_NOT_E164": "اكتب الرقم مع رمز الدولة (مثال: +1 555 …).",
  "error.DO_NOT_CALL": "هذا الرقم مدرج في قائمة عدم الاتصال.",
  "error.OUTBOUND_DISABLED": "المكالمات الصادرة غير مفعّلة في هذا التثبيت.",
  "error.HISTORY_NOT_CONFIGURED": "سجل المكالمات غير مفعّل في هذا التثبيت.",
  "error.DO_NOT_CALL_NOT_CONFIGURED": "قائمة عدم الاتصال غير مفعّلة في هذا التثبيت.",
  "calls.col.callbackState": "الحالة",
  "callback.state.scheduled": "سيتصل الوكيل: {at}",
  "callback.state.dialed": "اتصل الوكيل",
  "callback.state.expired": "فات الموعد، لم يتم الاتصال",
  "callback.state.notCalled": "تعذّر الاتصال: {reason}",
  "callback.state.manual": "سيتصل الفريق",
  "callback.openCall": "فتح مكالمة معاودة الاتصال",
  "callback.fromCall": "← هذه هي معاودة الاتصال التي وُعد بها في مكالمة سابقة",
  "error.BILLING_PRINCIPAL_MISSING": "لا يوجد حساب للفوترة.",
  "error.VOICE_MINUTES_EXCEEDED": "لم تتبقَّ دقائق اتصال.",
  "error.ORIGINATE_FAILED": "تعذّر فتح الخط.",
  "ambience.title": "صوت الخلفية",
  "ambience.hint": "صوت غرفة هادئ خلف المكالمة؛ ينخفض أثناء حديث الوكيل.",
  "ambience.bed.none": "بدون",
  "ambience.bed.office": "مكتب",
  "ambience.level": "المستوى",
  "ambience.save": "حفظ",
  "ambience.saved": "تم الحفظ — انشر لاستخدامه في المكالمات.",
  "error.DONE_BY_TEAM": "تولّى الفريق الأمر (أُلغيت المكالمة التلقائية)",
  "agent.tab.general": "عام",
  "agent.tab.voice": "الصوت",
  "agent.tab.knowledge": "المعرفة",
  "agent.tab.kit": "حزمة المبيعات",
  "agent.tab.compliance": "الامتثال",
  "agent.tab.test": "اختبار",
  "draft.differs": "توجد تغييرات لم تُنشر بعد (المنشور: الإصدار {live}، المسودة: الإصدار {draft}). انشرها لاستخدامها في المكالمات.",
  "draft.notPublished": "لم يُنشر هذا الوكيل بعد؛ تستخدم المكالمات الفعلية الإصدار المنشور.",
  "settings.identity": "الهوية",
  "settings.mission": "المهمة",
  "settings.maxSentences": "الحد الأقصى للجمل في كل إجابة",
  "settings.maxSentences.hint": "يُوصى بجملتين على الهاتف.",
  "settings.facts.hint": "ما يحاول الوكيل معرفته خلال المكالمة. يظهر في المحادثات بعد انتهاء المكالمة.",
  "settings.facts.label": "المعلومة",
  "settings.facts.type": "النوع",
  "settings.facts.required": "مطلوب",
  "settings.facts.add": "إضافة معلومة",
  "settings.facts.enumPlaceholder": "خيارات مفصولة بفواصل (مثال: تسجيل، معاودة اتصال)",
  "settings.factType.text": "نص",
  "settings.factType.boolean": "نعم/لا",
  "settings.factType.number": "رقم",
  "settings.factType.enum": "اختيار",
  "settings.factType.datetime": "التاريخ والوقت",
  "settings.factType.phone": "هاتف",
  "settings.factType.email": "البريد الإلكتروني",
  "settings.remove": "حذف",
  "settings.save": "حفظ",
  "settings.saving": "جارٍ الحفظ…",
  "settings.saved": "تم الحفظ — انشر لاستخدامه في المكالمات.",
  "settings.compliance": "عبارات إلزامية",
  "settings.compliance.hint": "يقول الوكيل هذه العبارات دائمًا في بداية المكالمة.",
  "settings.boundaries": "الحدود",
  "settings.blockedTopics": "مواضيع لا تُناقش أبدًا",
  "settings.mustNotPromise": "وعود لا تُقطع أبدًا",
  "settings.onePerLine": "عنصر واحد في كل سطر.",
  "assist.title": "أخبر الذكاء الاصطناعي",
  "assist.hint": "اكتب ما تريد تغييره بكلماتك؛ سترى التغيير المقترح ويُحفظ عند تطبيقه.",
  "assist.placeholder": "مثال: كن أكثر ودًّا واجعل الإجابات قصيرة",
  "assist.ask": "اقترح",
  "assist.thinking": "جارٍ التفكير…",
  "assist.proposal": "التغيير المقترح",
  "assist.noChange": "لم يُقترح أي تغيير.",
  "assist.apply": "تطبيق",
  "field.style.maxSentencesPerTurn": "الحد الأقصى للجمل في كل إجابة",
  "field.style.maxQuestionsPerTurn": "الحد الأقصى للأسئلة في كل إجابة",
  "field.style.humor": "الدعابة",
  "field.boundaries.blockedTopics": "مواضيع لا تُناقش أبدًا",
  "field.boundaries.mustNotPromise": "وعود لا تُقطع أبدًا",
  "field.timezone": "المنطقة الزمنية",
  "field.compliance.require": "عبارات إلزامية",
  "field.globalIntents": "النوايا",
  "field.statements": "إجابات النشاط التجاري",
  "field.ambience": "صوت الخلفية",
  "error.SPEC_FIELD_LOCKED": "لا يمكن تغيير هذا الحقل من هنا.",
  "error.SPEC_ASSIST_BAD_OUTPUT": "لم يتمكن الذكاء الاصطناعي من تقديم اقتراح صالح؛ أعد صياغة طلبك وحاول مرة أخرى.",
  "error.VALIDATION_FAILED": "بعض الحقول ناقصة أو غير صالحة.",
  "voice.title": "صوت الوكيل",
  "voice.hint": "كل صوت يقرأ عبارة وكيلك نفسه. استمع واختر واحدًا؛ بعد الحفظ والنشر ستستخدم المكالمات هذا الصوت.",
  "voice.filter.all": "الكل",
  "voice.filter.female": "أنثى",
  "voice.filter.male": "ذكر",
  "voice.gender.female": "أنثى",
  "voice.gender.male": "ذكر",
  "voice.speed": "سرعة التحدث",
  "voice.listen": "استماع",
  "voice.stop": "إيقاف",
  "voice.loading": "جارٍ التحضير…",
  "voice.default": "لم يتم اختيار صوت بعد؛ يُستخدم الصوت الافتراضي للمنصة.",
  "error.VOICES_NOT_CONFIGURED": "كتالوج الأصوات غير مفعّل في هذا التثبيت.",
  "error.VOICES_UNAVAILABLE": "قائمة الأصوات غير متاحة حاليًا.",
  "error.VOICE_SAMPLE_FAILED": "تعذّر إنشاء العيّنة.",
  "field.voice": "الصوت",
  "agent.back.short": "الوكلاء",
  "agent.status.live": "منشور",
  "agent.status.changed": "تغييرات غير منشورة",
  "agent.status.draft": "غير منشور",
  "agent.liveVersion": "الإصدار المنشور {v}",
  "agent.draftVersion": "إصدار المسودة {v}",
  "agent.publish.upToDate": "محدَّث",
  "settings.identity.hint": "الاسم الذي يعرّف به الوكيل نفسه والعلامة التجارية التي يمثلها.",
  "settings.personality": "الشخصية والأسلوب",
  "settings.personality.hint": "كيف يبدو كشخص. الإجابات القصيرة والواضحة تبدو أكثر طبيعية على الهاتف.",
  "settings.mission.hint": "سبب إجراء المكالمة، وما يُعدّ نجاحًا، ومن على الطرف الآخر. يختار الوكيل كل إجابة بناءً على ذلك.",
  "settings.boundaries.hint": "مواضيع لا يطرحها الوكيل أبدًا ووعود لا يقطعها أبدًا.",
  "settings.unsaved": "لديك تغييرات غير محفوظة",
  "settings.discard": "تجاهل",
  "common.sure": "هل أنت متأكد؟",
  "voice.search": "البحث عن الأصوات",
  "voice.own": "صوتك",
  "voice.chosen": "محدَّد",
  "voice.speed.hint": "1.00 هي السرعة العادية. السرعة الأبطأ قليلًا (0.95) قد تكون أوضح على الهاتف.",
  "voice.age.young": "شاب",
  "voice.age.middle_aged": "متوسط العمر",
  "voice.age.middle aged": "متوسط العمر",
  "voice.age.old": "ناضج",
  "voice.accent.american": "لكنة أمريكية",
  "voice.accent.british": "لكنة بريطانية",
  "voice.accent.australian": "لكنة أسترالية",
  "voice.accent.irish": "لكنة أيرلندية",
  "voice.accent.turkish": "تركية",
  "voice.accent.standard": "قياسية",
  "ambience.bed.none.hint": "بدون صوت في الخلفية.",
  "ambience.bed.office.hint": "أجواء مكتب هادئة؛ تنخفض أثناء حديث الوكيل.",
  "knowledge.source.label": "الإجابة",
  "knowledge.source.hint": "ما يقوله الوكيل عندما يسأل العميل “من أين حصلتم على رقمي؟”.",
  "knowledge.source.hint.required": "ما يقوله الوكيل عندما يسأل العميل “من أين حصلتم على رقمي؟”. مطلوب للوكلاء الذين يجرون مكالمات صادرة.",
  "knowledge.empty": "لا توجد إجابات للنشاط التجاري بعد. ابدأ بسؤال يطرحه العملاء كثيرًا.",
  "knowledge.done": "تم",
  "humor.light.hint": "يعترف بصدق عندما لا يعرف الإجابة، مع لمسة ودّية خفيفة.",
  "humor.off.hint": "يقول ذلك بوضوح وجدية عندما لا يعرف الإجابة.",
  "calls.search": "ابحث بالاسم أو الرقم أو الوكيل",
  "calls.prior": "المكالمات السابقة: {n}",
  "calls.counterpart.title": "المكالمات مع هذا الرقم",
  "calls.counterpart.counts": "المجموع: {total} · قبل هذه المكالمة: {before}",
  "calls.counterpart.none": "لا توجد مكالمات أخرى مع هذا الرقم.",
  "calls.counterpart.all": "عرض الكل",
  "calls.counterpart.inContacts": "في جهات الاتصال",
  "calls.counterpart.notInContacts": "غير موجود في جهات الاتصال",
  "calls.counterpart.name": "الاسم (اختياري)",
  "calls.counterpart.add": "إضافة إلى جهات الاتصال",
  "calls.counterpart.addHint": "يُحفظ الرقم والاسم الذي تكتبه فقط؛ لا يتم الاتصال بالشخص تلقائيًا. طلب حذف البيانات يحذف جهة الاتصال هذه أيضًا.",
  "calls.counterpart.added": "تمت الإضافة إلى جهات الاتصال.",
  "calls.counterpart.exists": "هذا الرقم موجود بالفعل في جهات الاتصال.",
  "calls.filter.sameNumber": "المكالمات مع هذا الرقم فقط",
  "calls.filter.clear": "إزالة التصفية",
  "calls.party.none": "لا يوجد رقم",
  "calls.kind.all": "الكل",
  "calls.kind.callback": "معاودة الاتصال",
  "calls.kind.talked": "تمت المحادثة",
  "calls.kind.machine": "بريد صوتي",
  "calls.kind.optedOut": "طلب عدم الاتصال",
  "voice.gender.neutral": "محايد",
  "app.subtitle": "عمليات العملاء",
  "app.workspace": "مساحة العمل",
  "nav.group.daily": "العمل اليومي",
  "nav.group.build": "الإنشاء",
  "nav.group.setup": "الإعداد",
  "nav.overview": "نظرة عامة",
  "nav.callbacks": "معاودات الاتصال",
  "nav.campaigns": "الحملات",
  "nav.leads": "العملاء المحتملون",
  "nav.doNotCall": "عدم الاتصال",
  "nav.agent": "وكلاء الذكاء الاصطناعي",
  "nav.calls": "المحادثات",
  "nav.call": "المحادثات",
  "theme.label": "المظهر",
  "theme.dark": "داكن",
  "theme.light": "فاتح",
  "overview.badge": "اليوم",
  "overview.strip": "ما حدث اليوم وما هو قادم — كله هنا.",
  "overview.refresh": "تحديث",
  "overview.queue.kicker": "قائمة الانتظار المباشرة",
  "overview.queue.title": "ما يحتاج إلى انتباهك",
  "overview.kpi.today": "مكالمات اليوم",
  "overview.kpi.talked": "تم التحدث",
  "overview.kpi.callbacks": "معاودات اتصال بالانتظار",
  "overview.kpi.machine": "البريد الصوتي",
  "overview.kpi.avg": "متوسط المكالمة",
  "overview.kpi.agents": "الوكلاء المنشورون",
  "overview.att.noAgent": "لا يوجد وكيل منشور",
  "overview.att.noAgent.body": "انشر وكيلًا لإجراء المكالمات.",
  "overview.att.noAgent.cta": "الانتقال إلى الوكلاء",
  "overview.att.manual": "{n} من معاودات الاتصال بانتظار فريقك",
  "overview.att.manual.body": "وُعد هؤلاء العملاء بمكالمة؛ ضع عليها علامة «تم» بعد الاتصال بهم.",
  "overview.att.callbacks.cta": "الانتقال إلى معاودات الاتصال",
  "overview.att.auto": "تمت جدولة {n} من معاودات الاتصال التلقائية",
  "overview.att.auto.body": "التالي: {at} · سيتصل {agent}.",
  "overview.att.changed": "{name}: تغييرات غير منشورة",
  "overview.att.changed.body": "لا تنعكس الإعدادات على المكالمات إلا بعد النشر.",
  "overview.att.changed.cta": "الانتقال إلى الوكيل",
  "overview.att.errors": "انتهت {n} مكالمة بخطأ تقني اليوم",
  "overview.att.errors.body": "راجع سجلات المكالمات لمعرفة السبب.",
  "overview.att.errors.cta": "مراجعة المكالمات",
  "overview.att.none": "لا يوجد ما ينتظر حاليًا",
  "overview.att.none.body": "تظهر المكالمات الجديدة ومعاودات الاتصال هنا فور ورودها.",
  "overview.command.kicker": "مركز القيادة",
  "overview.command.title": "ما الخطوة التالية؟",
  "overview.command.body": "ابدأ المكالمات، واستمع إلى المحادثات، وتابع معاودات الاتصال — الصفحة الرئيسية هي قائمة أعمالك.",
  "overview.command.call": "بدء مكالمة مع {name}",
  "overview.command.create": "إنشاء أول وكيل",
  "overview.command.review": "مراجعة المكالمات",
  "overview.command.callbacks": "معاودات الاتصال",
  "overview.step.create": "إنشاء",
  "overview.step.create.body": "أنشئ وكيلك بمساعدة الذكاء الاصطناعي في الاستوديو.",
  "overview.step.publish": "نشر",
  "overview.step.publish.body": "اختر الصوت والإعدادات، ثم انشر.",
  "overview.step.call": "اتصال",
  "overview.step.call.body": "اتصل برقم من صفحة الوكيل.",
  "overview.step.follow": "متابعة",
  "overview.step.follow.body": "استمع إلى التسجيلات وأغلق معاودات الاتصال.",
  "overview.recent": "المكالمات الأخيرة",
  "overview.recent.all": "عرض الكل",
  "calls.card": "بطاقة المكالمة",
  "calls.tile.duration": "المدة",
  "calls.tile.recording": "التسجيل",
  "calls.tile.turns": "مداخلات العميل",
  "calls.tile.ended": "أنهاها",
  "calls.tile.ready": "جاهز",
  "calls.endedBy.agent": "الوكيل",
  "calls.endedBy.caller": "الطرف الآخر",
  "calls.endedBy.error": "خطأ",
  "calls.cardTab.summary": "الملخص",
  "calls.cardTab.transcript": "المحادثة",
  "calls.cardTab.recording": "التسجيل",
  "calls.recording.hint": "الطرف الآخر في الأذن اليسرى، والوكيل في الأذن اليمنى.",
  "calls.list.kicker": "القائمة",
  "calls.list.title": "سجل المكالمات",
  "calls.kind.today": "اليوم",
  "calls.kind.recorded": "مسجّلة",
  "calls.none": "لا توجد مكالمات ضمن هذه التصفية.",
  "calls.pick": "اختر مكالمة من القائمة.",
  "agents.subtitle": "أنشئ، اضبط، انشر، ثم اختبر · {n} وكلاء",
  "agents.path.create": "إنشاء",
  "agents.path.tune": "ضبط",
  "agents.path.publish": "نشر",
  "agents.path.test": "مكالمة تجريبية",
  "agents.stat.total": "إجمالي الوكلاء",
  "agents.stat.outbound": "صادرة",
  "agents.stat.inbound": "واردة",
  "agents.stat.live": "منشور",
  "agents.filter.all": "الكل",
  "agents.filter.outbound": "صادرة",
  "agents.filter.inbound": "واردة",
  "agents.filter.live": "منشور",
  "agents.filter.draft": "مسودة / تغييرات",
  "agents.search": "البحث عن وكيل",
  "agents.open": "فتح",
  "agent.tab.actions": "الإجراءات",
  "actions.callback": "معاودة الاتصال",
  "actions.callback.hint": "هل يمكن للوكيل تحديد موعد والوعد بمعاودة الاتصال عندما يقول العميل «اتصلوا بي لاحقًا». عند تحديد المنطقة الزمنية، يتصل الوكيل بنفسه في ذلك الموعد.",
  "actions.callback.on": "يمكنه الوعد بمعاودة الاتصال",
  "actions.callback.on.hint": "يأخذ الموعد ويسجّله؛ ويتصل الوكيل عند حلوله.",
  "actions.callback.off": "لا يعد أبدًا بمعاودة الاتصال",
  "actions.callback.off.hint": "يقترح خطوة تالية أخرى.",
  "actions.callback.when": "متى تُقترح معاودة الاتصال",
  "actions.callback.when.hint": "يقترح الوكيل معاودة الاتصال في هذه الحالات؛ اكتبها بأسلوبك الخاص.",
  "actions.callback.defaultDescription": "العميل لا يستطيع التحدث الآن، أو يريد التحدث مع صاحب القرار، أو يوافق على أن يُتصل به لاحقًا",
  "actions.timezone": "المنطقة الزمنية",
  "actions.timezone.hint": "تُفهم المواعيد التي يذكرها العميل، مثل «غدًا 10:30»، وفق هذه المنطقة.",
  "actions.timezone.none": "غير محددة",
  "actions.timezone.browser": "استخدام منطقة هذا الجهاز ({zone})",
  "actions.timezone.needed": "بدون منطقة زمنية، لا تُجرى معاودات الاتصال تلقائيًا؛ بل تُضاف إلى قائمة الفريق.",
  "actions.hours": "ساعات الاتصال",
  "actions.hours.hint": "الأوقات التي يتصل فيها هذا الوكيل بنفسه (معاودة الاتصال، الحملات) والتي يمكنه أن يعد بمعاودة الاتصال فيها. ساعات المكالمات الواردة تُضبط لكل رقم في صفحة أرقام الهاتف.",
  "actions.hours.any": "في أي وقت",
  "actions.hours.any.hint": "بلا حدود زمنية.",
  "actions.hours.limited": "تحديد الأيام والساعات",
  "actions.hours.limited.hint": "اختر المنطقة الزمنية أولًا.",
  "actions.hours.start": "البداية",
  "actions.hours.end": "النهاية",
  "actions.hours.invalid": "اختر يومًا واحدًا على الأقل؛ ويجب أن تكون النهاية بعد البداية.",
  "day.1": "الإثنين",
  "day.2": "الثلاثاء",
  "day.3": "الأربعاء",
  "day.4": "الخميس",
  "day.5": "الجمعة",
  "day.6": "السبت",
  "day.7": "الأحد",
  "field.businessHours": "ساعات العمل",
  "error.OUTSIDE_HOURS": "خارج ساعات العمل",
  "actions.hours.limited.ready": "في الأيام المختارة، بين الساعات التي حددتها.",
  "agent.tab.conversation": "المحادثة",
  "pace.title": "إيقاع المحادثة",
  "pace.hint": "المدة التي ينتظر فيها الوكيل المتصل: قبل أن يقرر أنه انتهى من الكلام، وقبل أن يتحدث مجددًا عند الصمت، ولسماع «ألو» في البداية.",
  "pace.relaxed": "صبور",
  "pace.relaxed.hint": "ينتظر مدة أطول؛ للمتصلين الذين يفكرون أو يتحدثون ببطء.",
  "pace.normal": "عادي",
  "pace.normal.hint": "موصى به لمعظم المكالمات.",
  "pace.quick": "سريع",
  "pace.quick.hint": "للمكالمات القصيرة والسريعة الإيقاع.",
  "field.pace": "إيقاع المحادثة",
  "studio.templates.kicker": "بداية سريعة",
  "studio.templates.title": "أنشئ وكيلك بالمحادثة",
  "studio.templates.hint": "يسأل الذكاء الاصطناعي خطوة بخطوة وتجيب أنت. للبدء بسرعة بوكيل جاهز اختر \"وكلاء جاهزون\".",
  "studio.templates.blank": "البدء من الصفر",
  "studio.templates.blank.hint": "يبنيه الذكاء الاصطناعي معك بدءًا من السؤال الأول.",
  "error.TEMPLATE_NOT_FOUND": "القالب غير موجود.",
  "nav.contacts": "جهات الاتصال",
  "nav.campaign": "الحملات",
  "contacts.title": "جهات الاتصال",
  "contacts.subtitle": "الأشخاص الذين تتصل بهم الحملات · {n} جهة اتصال",
  "contacts.import": "إضافة جماعية (Excel / CSV)",
  "contacts.file": "اختيار ملف CSV",
  "contacts.import.hint": "انسخ الصفوف من Excel أو Google Sheets والصقها، أو اختر ملف CSV. يُكتشف عمود الهاتف تلقائيًا؛ وإذا كان الصف الأول عناوين، تُحفظ الأعمدة الأخرى كمعلومات إضافية. اكتب الأرقام مع رمز الدولة (+…).",
  "contacts.import.placeholder": "الاسم\tالهاتف\tالمدينة\nAcme Ltd\t+1 555 000 0001\tBoston",
  "contacts.preview": "تم العثور على {n} صف · الأعمدة: {columns}",
  "contacts.add": "إضافة {n} جهة اتصال",
  "contacts.imported": "أُضيفت {inserted} جهة اتصال جديدة، وحُدّثت {updated}، و{invalid} صف يحتوي على رقم غير صالح.",
  "contacts.search": "البحث بالاسم أو الرقم",
  "contacts.empty": "لا توجد جهات اتصال بعد. أضف بعضها من الأعلى.",
  "contacts.col.name": "الاسم",
  "contacts.col.fields": "معلومات إضافية",
  "campaigns.title": "الحملات",
  "campaigns.subtitle": "وكيل يتصل بجهات اتصالك واحدة تلو الأخرى؛ ويُعاد الاتصال بمن لم يُتوصل إليهم.",
  "campaigns.new": "حملة جديدة",
  "campaigns.empty": "لا توجد حملات بعد.",
  "campaigns.status.draft": "مسودة",
  "campaigns.status.running": "جارٍ الاتصال",
  "campaigns.status.paused": "متوقفة مؤقتًا",
  "campaigns.status.done": "مكتملة",
  "campaigns.status.cancelled": "ملغاة",
  "campaigns.targets": "{n} جهة اتصال",
  "campaigns.stat.total": "الإجمالي",
  "campaigns.stat.pending": "في الانتظار",
  "campaigns.stat.dialing": "جارٍ الاتصال",
  "campaigns.stat.done": "تم التحدث",
  "campaigns.stat.failed": "لم يُتوصل إليه",
  "campaigns.stat.skipped": "تم تخطيه",
  "campaigns.stat.left": "متبقٍ",
  "campaigns.step.1": "الاسم والوكيل",
  "campaigns.step.2": "جهات الاتصال",
  "campaigns.step.3": "الإعدادات",
  "campaigns.step.4": "الملخص",
  "campaigns.name": "اسم الحملة",
  "campaigns.name.placeholder": "مثال: أكتوبر — عيادات الرياض",
  "campaigns.agent": "الوكيل المتصل",
  "campaigns.agent.hint": "تُعرض فقط الوكلاء المنشورون الذين يجرون مكالمات.",
  "campaigns.agent.none": "لا يوجد وكيل منشور يمكنه إجراء المكالمات؛ انشر وكيلًا أولًا.",
  "campaigns.contacts.none": "لا توجد جهات اتصال بعد.",
  "campaigns.contacts.go": "الانتقال إلى جهات الاتصال",
  "campaigns.picked": "تم اختيار {n} / {total}",
  "campaigns.all": "الكل",
  "campaigns.none": "لا شيء",
  "campaigns.concurrency": "المكالمات المتزامنة",
  "campaigns.concurrency.hint": "عدد الأشخاص الذين يُتصل بهم في الوقت نفسه. اختر حسب عدد المكالمات التي يتحملها خطك؛ وإن لم تكن متأكدًا، فاختر 1.",
  "campaigns.attempts": "عدد المحاولات",
  "campaigns.attempts.hint": "يُعاد الاتصال بالمكالمات التي لم يُرد عليها، أو التي وصلت إلى البريد الصوتي، أو انقطعت فورًا، حتى هذا العدد من المرات.",
  "campaigns.retry": "إعادة المحاولة بعد",
  "campaigns.minutes": "{n} دقيقة",
  "campaigns.hours": "{n} ساعة",
  "campaigns.day": "يوم واحد",
  "campaigns.hours.note": "تُجرى المكالمات خلال ساعات عمل الوكيل (الوكيل ← الإجراءات). لا يتم الاتصال أبدًا بالأرقام المدرجة في قائمة عدم الاتصال.",
  "campaigns.confirm": "سيتم الاتصال بـ {n} شخص. تُحتسب كل مكالمة بالدقيقة. هل تريد البدء؟",
  "campaigns.confirm.yes": "نعم، ابدأ",
  "campaigns.saveDraft": "حفظ كمسودة",
  "campaigns.createStart": "إنشاء وبدء",
  "campaigns.start": "بدء",
  "campaigns.resume": "استئناف",
  "campaigns.pause": "إيقاف مؤقت",
  "campaigns.cancel": "إلغاء الحملة",
  "campaigns.settings": "{c} في وقت واحد · {a} محاولات · كل {r} دقيقة",
  "campaigns.col.status": "الحالة",
  "campaigns.col.attempts": "المحاولات",
  "campaigns.target.pending": "في الانتظار",
  "campaigns.target.dialing": "جارٍ الاتصال",
  "campaigns.target.done": "تمت المحادثة",
  "campaigns.target.failed": "لم يتم الوصول",
  "campaigns.target.skipped": "تم التخطي",
  "campaigns.result.talked": "تمت المحادثة",
  "campaigns.result.callback": "معاودة الاتصال",
  "campaigns.result.opted_out": "طلب عدم الاتصال به",
  "campaigns.result.no_answer": "لا يوجد رد",
  "campaigns.result.voicemail": "بريد صوتي",
  "campaigns.result.error": "خطأ تقني",
  "campaigns.result.skipped": "تم التخطي",
  "campaigns.result.retry": "ستُعاد المحاولة لاحقًا",
  "error.CAMPAIGN_FINISHED": "هذه الحملة انتهت أو أُلغيت.",
  "error.CAMPAIGN_NOT_FOUND": "الحملة غير موجودة.",
  "error.CONTACT_NOT_FOUND": "جهة الاتصال غير موجودة.",
  "leads.title": "العملاء المحتملون",
  "leads.subtitle": "مسار المبيعات · {n} جهة اتصال · {hot} ساخن",
  "leads.empty": "لا توجد جهات اتصال بعد. أضف جهات اتصال وابدأ حملة، وستظهر المكالمات هنا.",
  "leads.openCall": "آخر مكالمة",
  "leads.notCalled": "لم يتم الاتصال بعد",
  "leads.moveTo": "نقل إلى مرحلة",
  "leads.score.hot": "ساخن",
  "leads.score.warm": "دافئ",
  "leads.score.cold": "بارد",
  "leads.stage.new": "جديد",
  "leads.stage.contacted": "تم التواصل",
  "leads.stage.interested": "مهتم",
  "leads.stage.callback": "معاودة الاتصال",
  "leads.stage.won": "مكسوب",
  "leads.stage.lost": "خسارة",
  "calls.analysis": "ملخص المكالمة",
  "calls.nextAction": "الخطوة التالية:",
  "calls.sentiment.positive": "إيجابي",
  "calls.sentiment.neutral": "محايد",
  "calls.sentiment.negative": "سلبي",
  "contacts.col.stage": "المرحلة",
  "contacts.col.kind": "النوع",
  "contacts.kind.label": "نوع الرقم",
  "contacts.kind.hint": "«غير معروف» يُعامل كفرد (الجانب الحذر).",
  "contacts.kind.business": "تجاري",
  "contacts.kind.person": "فرد",
  "contacts.kind.unknown": "غير معروف",
  "contacts.kind.all": "الكل",
  "contacts.kind.header.aliases": "نوع الرقم|النوع",
  "contacts.kind.business.aliases": "تجاري|منشأة",
  "contacts.kind.person.aliases": "فرد|شخصي|فردي",
  "contacts.kind.unknown.aliases": "غير معروف",
  "lines.title": "خطوط الهاتف",
  "lines.subtitle": "اربط خط SIP الخاص بك، واختر الوكيل الذي يرد على كل رقم والرقم الذي يتصل منه كل وكيل.",
  "lines.add": "إضافة خط",
  "lines.edit": "تعديل",
  "lines.save": "حفظ واتصال",
  "lines.saved": "تم الحفظ.",
  "lines.applied": "تم تطبيق الخطوط على المقسم.",
  "lines.notApplied": "تم الحفظ، لكن تعذّر تحديث المقسم حاليًا.",
  "lines.retry": "إعادة المحاولة",
  "lines.empty": "لا توجد خطوط بعد. أضف خطك الأول باستخدام اسم المستخدم وكلمة المرور من مزوّد SIP الخاص بك.",
  "lines.provider.verimor": "Verimor",
  "lines.provider.zadarma": "Zadarma",
  "lines.provider.sip": "SIP آخر",
  "lines.provider.verimor.hint": "اسم المستخدم (عادةً رقمك) وكلمة المرور من قسم المقسم ← حسابات SIP في لوحة Verimor.",
  "lines.provider.zadarma.hint": "اسم دخول SIP (مثل 123456-100) وكلمة المرور من قسم الإعدادات ← اتصال SIP في حسابك على Zadarma.",
  "lines.provider.sip.hint": "خادم SIP واسم المستخدم وكلمة المرور من مزوّد الخدمة. يتصل الخط عن طريق التسجيل.",
  "lines.label": "اسم الخط",
  "lines.label.hint": "للاستخدام الخاص بك، مثل: خط المبيعات.",
  "lines.username": "اسم مستخدم SIP",
  "lines.username.hint": "اسم المستخدم الذي قدّمه لك مزوّد الخدمة.",
  "lines.password": "كلمة مرور SIP",
  "lines.password.keep": "اتركه فارغًا للإبقاء على كلمة المرور الحالية.",
  "lines.host": "خادم SIP",
  "lines.port": "المنفذ",
  "lines.authUsername": "مستخدم المصادقة",
  "lines.authUsername.hint": "فقط إذا قدّم لك مزوّد الخدمة مستخدمًا منفصلًا.",
  "lines.advanced": "إعدادات متقدمة",
  "lines.secretNote": "تُخزَّن كلمة المرور مشفّرة ولن تُعرض مرة أخرى.",
  "lines.system": "خط النظام",
  "lines.state.registered": "متصل",
  "lines.state.rejected": "رُفض اسم المستخدم/كلمة المرور",
  "lines.state.unreachable": "تعذّر الوصول إلى الخادم",
  "lines.state.pending": "جارٍ الاتصال…",
  "lines.state.unknown": "الحالة غير متاحة",
  "lines.unverified": "تصل المكالمات الواردة إلى أرقام هذا الخط بعد أن يتصل الخط بنجاح لأول مرة.",
  "lines.number": "الرقم",
  "lines.numberLabel": "الوصف",
  "lines.numberLabel.placeholder": "مثل: الخط الرئيسي",
  "lines.inboundAgent": "يرد عليه",
  "lines.inbound.none": "لا يرد عليه V2",
  "lines.notPublished": "غير منشور",
  "lines.addNumber": "إضافة رقم",
  "lines.numberAdded": "تمت إضافة الرقم.",
  "lines.outbound.title": "من أي رقم يتصل الوكلاء؟",
  "lines.outbound.hint": "يمكن لكل وكيل الاتصال من رقمه الخاص. وإلا فسيُستخدم الخط الافتراضي للمنصة.",
  "lines.agent": "الوكيل",
  "lines.outbound.number": "رقم المتصل",
  "lines.outbound.default": "الخط الافتراضي",
  "error.SIP_FIELD_INVALID": "أحد الحقول غير صالح. يجب أن يكون الخادم اسم مضيف بأحرف صغيرة أو عنوان IP؛ ويجب ألا يحتوي اسم المستخدم على مسافات أو @؛ ولا يمكن أن تحتوي كلمة المرور على شرطة مائلة عكسية (\\).",
  "error.PROVIDER_UNKNOWN": "مزوّد غير معروف.",
  "error.NUMBER_TAKEN": "هذا الرقم مسجّل لنشاط تجاري آخر على المنصة.",
  "error.LINE_NOT_FOUND": "الخط غير موجود.",
  "error.NUMBER_NOT_FOUND": "الرقم غير موجود.",
  "error.TELEPHONY_NOT_CONFIGURED": "خطوط الهاتف غير مفعّلة في هذا التثبيت بعد.",
  "numbers.title": "أرقام الهاتف",
  "numbers.subtitle": "أضف أرقام SIP الخاصة بنشاطك التجاري؛ واختر الوكيل الذي يرد على كل رقم والوكلاء الذين يتصلون منه.",
  "numbers.add": "إضافة رقم",
  "numbers.step.1": "حساب SIP",
  "numbers.step.2": "الرقم",
  "numbers.step.3": "الوكلاء",
  "numbers.newAccount": "ربط حساب SIP جديد",
  "numbers.newAccount.hint": "باستخدام اسم المستخدم وكلمة المرور من مزوّد الخدمة.",
  "numbers.accountCreated": "تم ربط حساب SIP. تابع بإضافة الرقم.",
  "numbers.e164.hint": "مع رمز الدولة (+90…). بعد ذلك يصبح الرقم خاصًا بنشاطك التجاري وحده على المنصة.",
  "numbers.inbound": "يرد عليه",
  "numbers.inbound.hint": "الوكيل الذي يتحدث مع من يتصلون بهذا الرقم. يمكن اختيار الوكلاء المنشورين فقط.",
  "numbers.outbound": "الوكلاء الذين يتصلون من هذا الرقم",
  "numbers.outbound.hint": "يظهر هذا الرقم لدى هؤلاء الوكلاء في المكالمات الصادرة (المكالمات الفردية، الحملات، معاودة الاتصال). يتصل الوكيل من رقم واحد.",
  "numbers.nowUses": "حاليًا {number}",
  "numbers.noAgents": "لا يوجد وكلاء بعد.",
  "numbers.back": "رجوع",
  "numbers.next": "متابعة",
  "numbers.finish": "إضافة الرقم",
  "numbers.added": "تمت إضافة الرقم وربطه بالوكلاء.",
  "numbers.empty": "لا توجد أرقام بعد. استخدم «إضافة رقم» لربط حساب SIP الخاص بك وإضافة رقمك الأول.",
  "numbers.account": "حساب SIP",
  "numbers.addCaller": "+ إضافة وكيل",
  "numbers.defaultNote": "الوكلاء غير المرتبطين برقم يتصلون من الخط الافتراضي للمنصة.",
  "numbers.plan": "ساعات العمل",
  "numbers.plan.always": "مفتوح دائمًا",
  "numbers.plan.add": "تحديد الساعات",
  "numbers.plan.needAgent": "اختر أولًا الوكيل الذي يجيب على هذا الرقم.",
  "numbers.plan.now.open": "مفتوح الآن",
  "numbers.plan.now.closed": "مغلق الآن",
  "numbers.plan.now.holiday": "مغلق اليوم",
  "numbers.plan.after.same": "خارج ساعات العمل: الوكيل نفسه",
  "numbers.plan.after.agent": "خارج ساعات العمل: {agent}",
  "numbers.plan.after.refuse": "خارج ساعات العمل: لا يتم الرد",
  "plan.title": "ساعات العمل · {number}",
  "plan.edit": "تعديل",
  "plan.scopeNote": "هذه الساعات خاصة بالمكالمات الواردة إلى هذا الرقم فقط. أما أوقات اتصال الوكلاء (معاودة الاتصال، الحملات) فتُضبط في تبويب الإجراءات لكل وكيل.",
  "plan.mode.always": "دائمًا",
  "plan.mode.always.hint": "بلا قيود؛ تذهب كل مكالمة إلى الوكيل نفسه كما هو الآن.",
  "plan.mode.limited": "في أيام وساعات محددة",
  "plan.timezone.agent": "استخدم منطقة الوكيل ({zone})",
  "plan.copyAgent": "انسخ ساعات اتصال الوكيل",
  "plan.day.closed": "مغلق",
  "plan.day.allDay": "24 ساعة",
  "plan.window.add": "+ فترة ثانية",
  "plan.window.remove": "إزالة الفترة",
  "plan.applyAll": "طبّق هذه الساعات على جميع الأيام المفتوحة",
  "plan.overnight.hint": "للساعات بعد منتصف الليل استخدم يومين (مثل 22:00–24:00 ثم 00:00–02:00 في اليوم التالي).",
  "plan.closedDates": "أيام الإغلاق",
  "plan.closedDates.hint": "العطل وما شابهها. تُعدّ جميع الأرقام مغلقة طوال ذلك اليوم (كلٌّ حسب منطقته الزمنية)؛ وما يحدث حينها يحدده إعداد خارج ساعات العمل لكل رقم. تُضاف من جديد كل عام.",
  "plan.closedDates.add": "إضافة",
  "plan.closedDates.empty": "لا توجد أيام إغلاق.",
  "plan.closedDates.workspaceNote": "أيام الإغلاق (العطل) مشتركة بين جميع الأرقام؛ تُضاف من بطاقة \"أيام الإغلاق\" أسفل الصفحة.",
  "plan.after": "المكالمات خارج هذه الساعات",
  "plan.after.same": "يجيب الوكيل نفسه",
  "plan.after.same.hint": "كما هو الآن. لا يعرف الوكيل أن الوقت خارج ساعات العمل؛ لا تتم محاولة التحويل الهاتفي إلى شخص، ويأخذ الوكيل رسالة.",
  "plan.after.agent": "يجيب وكيل آخر",
  "plan.after.agent.hint": "مثلًا وكيل يأخذ الرسائل فقط. ما يقوله، بما في ذلك الإفصاحات، يأتي من إعداداته الخاصة. إذا تعذّر عليه الرد (غير منشور، لا رصيد) يجيب وكيل الرقم الأساسي.",
  "plan.after.agent.pick": "اختر وكيلًا",
  "plan.after.agent.noHours": "ليس لهذا الوكيل ساعات اتصال خاصة به: قد يجري معاودات الاتصال الموعودة في أي ساعة. اضبطها من الوكيل ← الإجراءات.",
  "plan.after.agent.noNumber": "لا يتصل هذا الوكيل من أي رقم من أرقامك؛ تتم معاودات اتصاله من رقم المنصة الافتراضي.",
  "plan.after.refuse": "لا يتم الرد",
  "plan.after.refuse.hint": "لا تذهب المكالمة إلى أي وكيل ولا يُنشأ سجل مكالمة؛ يُحفظ العدد فقط ولا يُحفظ من اتصل. اختر أدناه ما يسمعه المتصل.",
  "plan.refuse.style": "ماذا يسمع المتصل؟",
  "plan.refuse.ring": "يرن ولا يجيب أحد",
  "plan.refuse.ring.hint": "مثل مكتب مغلق؛ لا تُحتسب رسوم. عند انتهاء المهلة قد يشغّل المشغّل إعلانه الخاص.",
  "plan.refuse.message": "تُشغَّل رسالة الإغلاق",
  "plan.refuse.message.hint": "يتم الرد على المكالمة وتُقرأ الرسالة أدناه بصوت الوكيل ثم تُنهى؛ تُحتسب دقائق الخط.",
  "plan.refuse.reject": "تُرفض فورًا",
  "plan.refuse.reject.hint": "تُرفض قبل الرد؛ ويشغّل المشغّل إعلانًا مثل \"لا يمكن استخدام الرقم الداخلي\".",
  "plan.refuse.message.placeholder": "مثال: نحن خارج ساعات العمل الآن. يمكنكم التواصل معنا أيام الأسبوع بين 09:00 و18:00.",
  "plan.refuse.message.note": "تُسجَّل صوتيًا مرة واحدة عند الحفظ. المتبقي: {n} حرفًا.",
  "plan.refuse.message.listen": "استمع إلى الرسالة المحفوظة",
  "plan.refused": "المرفوضة خارج ساعات العمل: اليوم {today}، آخر 7 أيام {week}",
  "plan.preview": "الآن {day} {time} ({zone}): {state}. {answer}",
  "plan.preview.note": "(حسب الخطة المحفوظة؛ تظهر التغييرات بعد الحفظ.)",
  "plan.state.open": "مفتوح",
  "plan.state.closed": "مغلق",
  "plan.state.holiday": "يوم إغلاق",
  "plan.answer.agent": "يجيب {agent}.",
  "plan.answer.nobody": "لا يتم الرد على المكالمة.",
  "plan.invalid.window": "يجب أن يكون وقت الانتهاء بعد البدء وألا تتداخل الفترات.",
  "plan.invalid.empty": "حدّد ساعات ليوم واحد على الأقل.",
  "plan.remove": "إزالة الساعات",
  "calls.afterHours": "خارج ساعات العمل",
  "calls.closedDay": "يوم إغلاق",
  "numbers.accounts": "حسابات SIP المرتبطة",
  "numbers.accounts.hint": "يمكن للنشاط التجاري ربط عدة حسابات؛ ويمكن أن يحتوي كل حساب على عدة أرقام.",
  "numbers.count": "{n} أرقام",
  "lines.test": "اختبار",
  "lines.connectTest": "اتصال واختبار",
  "lines.test.again": "إعادة الاختبار",
  "lines.test.busy": "جارٍ الاتصال…",
  "lines.test.running": "جارٍ الاتصال بمزوّد الخدمة… ({s} ث)",
  "lines.test.ok": "تم الاتصال: سُجّل الخط لدى مزوّد الخدمة. يمكنك المتابعة.",
  "lines.test.rejected": "رفض مزوّد الخدمة اسم المستخدم أو كلمة المرور. صحّحهما وأعد الاختبار.",
  "lines.test.waiting": "لا يوجد رد من مزوّد الخدمة بعد. يمكنك المتابعة؛ وستظهر حالة الاتصال في القائمة.",
  "lines.test.unknown": "تعذّرت قراءة حالة الاتصال حاليًا. يمكنك المتابعة؛ وستظهر الحالة في القائمة.",
  "lines.invalid.host": "«خادم SIP» غير صالح: أدخل اسم مضيف بأحرف صغيرة (مثل sip.example.com) أو عنوان IP، بدون http:// أو مسافات.",
  "lines.invalid.username": "«اسم مستخدم SIP» غير صالح: بدون مسافات وبدون أي من: @ ; : # % \" < > [ ] \\",
  "lines.invalid.authUsername": "«مستخدم المصادقة» غير صالح: بدون مسافات وبدون أي من: @ ; : # % \" < > [ ] \\",
  "lines.invalid.password": "«كلمة مرور SIP» غير صالحة: 128 حرفًا كحد أقصى، بدون مسافات أو شرطة مائلة عكسية (\\).",
  "lines.invalid.port": "يجب أن يكون «المنفذ» بين 1 و65535.",
  "error.LINE_EXISTS": "حساب SIP هذا (نفس الخادم واسم المستخدم) مرتبط بالفعل على المنصة. إضافته مرة ثانية ستقطع الاتصال الحالي؛ استخدم الخط الموجود في القائمة.",
  "numbers.sameAccount": "حساب SIP هذا مرتبط بالفعل («{name}»). اخترتُ ذلك الخط وأقوم باختبار اتصاله.",
  "numbers.alreadyListed": "هذا الرقم موجود بالفعل في قائمتك. اختر الوكيل الذي يرد عليه والوكلاء الذين يتصلون منه في جدول الأرقام.",
  "agent.tab.routing": "التوجيه",
  "routing.title": "التوجيه حسب الموضوع",
  "routing.hint": "اكتب بكلماتك الخاصة المواضيع التي يسأل عنها المتصلون، واختر وجهة كل منها. يفهم الوكيل ما يحتاجه المتصل، ويطرح سؤالًا واحدًا عند الحاجة، ثم يحوّل المكالمة إلى الوكيل أو الرقم الذي اخترته، أو يدوّن رسالة. إذا كانت القائمة فارغة، يتولى الوكيل كل المكالمات بنفسه.",
  "routing.empty": "لا توجد مواضيع بعد. أضف مواضيع لوكيل الاستقبال (مثل: الحجوزات، الفواتير، الدعم الفني).",
  "routing.topic": "الموضوع",
  "routing.topic.placeholder": "اسم الموضوع (مثل: الحجوزات)",
  "routing.description": "ما يشمله",
  "routing.description.placeholder": "ماذا يريد المتصلون هنا؟ (مثل: حجز جديد، تغيير الموعد، إلغاء)",
  "routing.target": "الوجهة",
  "routing.target.self": "يدوّن الوكيل رسالة",
  "routing.target.agent": "تسليم إلى وكيل ذكاء اصطناعي: {name}",
  "routing.target.phone": "تحويل إلى رقم هاتف",
  "routing.phone": "رقم التحويل",
  "routing.add": "إضافة موضوع",
  "routing.needCallback": "للمواضيع التي يدوّن فيها الوكيل رسالة، فعّل معاودة الاتصال في تبويب الإجراءات حتى يتمكن الوكيل من الاتفاق على موعد مع المتصل.",
  "routing.badPhone": "اكتب رقم التحويل مع رمز الدولة (+966…).",
  "routing.phoneNote": "يتم التحويل عبر الخط الذي وردت منه المكالمة. إذا لم يرد أحد (مشغول، خارج ساعات العمل) تعود المكالمة إلى الوكيل، فيعتذر ويدوّن الموضوع وموعدًا لمعاودة الاتصال.",
  "routing.phone.placeholder": "+966 5x xxx xxxx",
  "routing.summary": "تحويل المتصل: {connected} من {total} · تدوين رسالة: {message}",
  "routing.allMessage": "لا يوجد موضوع يوصل المتصل بأحد؛ في كل المواضيع يدوّن الوكيل رسالة.",
  "routing.notPublished": "الوكيل المختار غير منشور بعد، فلا يمكن تحويل المكالمات إليه. وإلى أن يُنشر، يدوّن هذا الوكيل رسالة في هذا الموضوع.",
  "studio.askingNow": "يُسأل الآن",
  "fieldHelp.identity.brandName": "يذكر الوكيل في كل مكالمة أنه يتحدث باسم هذا النشاط التجاري.",
  "fieldHelp.identity.name": "يعرّف الوكيل نفسه بهذا الاسم («أنا سارة»). اختر اسمًا ودودًا أو اسمًا يناسب علامتك التجارية.",
  "fieldHelp.identity.persona": "كيف يبدو الوكيل للآخرين: مثل «مستشار ودود وصبور» أو «مساعد سريع وواضح».",
  "fieldHelp.languages.primary": "اللغة التي يتحدث بها الوكيل ويفهمها على الهاتف.",
  "fieldHelp.direction": "هل سيتصل الوكيل بالناس (صادرة) أم سيرد على المكالمات الموجهة إلى نشاطك التجاري (واردة)؟ تتغير عبارته الافتتاحية بناءً على ذلك.",
  "fieldHelp.mission.goal": "ما يسعى لتحقيقه في كل مكالمة؛ ويوجّه المحادثة نحوه. مثل: «حجز موعد».",
  "fieldHelp.mission.audience": "الأشخاص الذين يتحدث معهم؛ يختار الكلمات والأمثلة المناسبة لهم.",
  "fieldHelp.mission.successCondition": "ما الذي يجعل المكالمة ناجحة (مثل: تم حجز موعد). تستخدمه ملخصات المكالمات والتقارير.",
  "fieldHelp.facts": "ما يجب معرفته خلال المكالمة (مثل: الاسم، الحاجة، الوقت المناسب). يظهر في بطاقة المكالمة وفي التقارير.",
  "fieldHelp.style.tone": "طابع المحادثة: مثل «ودود ومختصر» أو «رسمي ومهذب». يُطبَّق على كل جملة.",
  "fieldHelp.compliance.require[recording_notice].instruction": "الجملة التي تفيد بأن المكالمة مسجّلة. متطلب قانوني في كثير من الدول؛ تُقال في بداية كل مكالمة.",
  "fieldHelp.compliance.require[ai_disclosure].instruction": "الجملة التي تُخبر الشخص بأنه يتحدث مع مساعد ذكاء اصطناعي، حتى لا يُضلَّل أحد.",
  "fieldHelp.globalIntents[opt_out].description": "كيف يتعرّف على عبارة «لا تتصل بي مرة أخرى»؛ ولن يتم الاتصال بذلك الرقم مرة أخرى أبدًا.",
  "lang.label": "اللغة",
  "crash.title": "حدث خطأ في هذه الصفحة",
  "crash.hint": "أعد تحميل الصفحة. إذا تكرر الخطأ، أرسل النص أدناه إلى فريق الدعم.",
  "crash.reload": "إعادة تحميل الصفحة",
  "nav.testRoom": "غرفة الاختبار",
  "room.title": "غرفة الاختبار",
  "room.subtitle": "دع وكيلك يتحدث مع عميل افتراضي بأصوات حقيقية. تُسجَّل المحادثة كمكالمة حقيقية دون استخدام خط هاتف أو دقائق.",
  "room.agent": "الوكيل المراد اختباره",
  "room.noAgents": "لا يوجد وكيل منشور بعد. انشر وكيلًا أولًا.",
  "room.direction": "اتجاه المكالمة",
  "room.direction.outbound": "الوكيل يتصل بالعميل",
  "room.direction.inbound": "العميل يتصل بالنشاط التجاري",
  "room.persona": "نوع العميل",
  "room.persona.interested": "مهتم",
  "room.persona.interested.hint": "يجيب عن الأسئلة ويسأل أسئلة عملية ويقبل خطوة تالية واضحة.",
  "room.persona.busy": "مشغول",
  "room.persona.busy.hint": "في منتصف العمل؛ إجابات قصيرة جدًا ويقبل عرض معاودة الاتصال السريع.",
  "room.persona.skeptical": "متشكك",
  "room.persona.skeptical.hint": "يسأل من أين حصلت على الرقم وماذا تبيع وكم السعر؛ يريد إجابات مباشرة.",
  "room.persona.rude": "فظ",
  "room.persona.rude.hint": "منزعج من المكالمة؛ قصير وحاد. يختبر هدوء الوكيل.",
  "room.persona.refusal": "رافض",
  "room.persona.refusal.hint": "غير مهتم بوضوح؛ يختبر إنهاء الوكيل للمكالمة بلطف.",
  "room.persona.confused": "مرتبك",
  "room.persona.confused.hint": "لا يفهم ويسأل مجددًا؛ يختبر الشرح البسيط.",
  "room.persona.competitor_happy": "راضٍ عن منافس",
  "room.persona.competitor_happy.hint": "يعمل مع شركة أخرى وراضٍ؛ يختبر قدرة الوكيل على إبراز الفرق.",
  "room.scenario": "وضع العميل (اختياري)",
  "room.scenario.placeholder": "مثال: لديه حجز غدًا ويريد الإلغاء دون دفع رسوم.",
  "room.scenario.hint": "صف موقفًا حقيقيًا من عملائك؛ سيتحدث العميل الافتراضي كأنه يعيشه.",
  "room.voice": "صوت العميل",
  "room.voice.default": "الافتراضي للمنصة",
  "room.start": "ابدأ المحادثة",
  "room.starting": "جارٍ البدء…",
  "room.cost": "لا تُستهلك دقائق هاتف؛ يُحتسب استخدام الذكاء الاصطناعي فقط.",
  "room.history": "المحادثات الأخيرة",
  "room.empty": "لا توجد محادثات اختبار بعد.",
  "room.pick": "ابدأ محادثة من اليسار أو اختر واحدة من القائمة.",
  "room.running": "المحادثة جارية… يظهر التسجيل والنص هنا عند انتهائها.",
  "room.failed": "تعذّر بدء المحادثة. حاول مرة أخرى بعد قليل.",
  "room.status.created": "يبدأ",
  "room.status.live": "جارية",
  "room.status.ended": "انتهت",
  "room.status.failed": "فشلت",
  "room.heard.title": "هل سمع الوكيل بشكل صحيح؟",
  "room.heard.hint": "على اليمين ما قاله العميل وعلى اليسار ما سمعه الوكيل. الفروق تكشف أخطاء التعرف على الكلام.",
  "room.heard.said": "قال العميل",
  "room.heard.heard": "سمع الوكيل",
  "room.heard.none": "(لم يُسمع)",
  "error.ROOM_NOT_CONFIGURED": "غرفة الاختبار غير متاحة في هذا التثبيت.",
  "nav.room": "غرفة الاختبار",
  "templates.agentLanguage": "اللغة التي يتحدث بها الوكيل",
  "templates.language.tr-TR": "التركية",
  "templates.language.en-US": "الإنجليزية",
  "templates.language.ar-SA": "العربية",
  "templates.sector": "القطاع",
  "templates.structure": "نوع المكالمة",
  "templates.direction": "اتجاه المكالمة",
  "templates.all": "الكل",
  "templates.own": "قالبك",
  "templates.otherLanguage": "غير متوفر بهذه اللغة (يُعرض {lang})",
  "templates.none": "لا يوجد قالب مطابق. غيّر عوامل التصفية أو ابدأ من الصفر.",
  "templates.filled": "تمت تعبئة القالب بمعلومات نشاطك: {list}.",
  "templates.unresolved": "غير موجود في قاعدة معرفتك (سيسأل الاستوديو عند الحاجة): {list}.",
  "templates.var.business.name": "اسم النشاط",
  "templates.var.business.website": "الموقع الإلكتروني",
  "templates.var.business.phone": "الهاتف",
  "templates.var.business.email": "البريد الإلكتروني",
  "templates.var.business.address": "العنوان",
  "templates.var.business.city": "المدينة",
  "templates.var.business.hours": "ساعات العمل",
  "templates.var.business.offer": "ما تقدمه",
  "sector.general": "عام",
  "sector.hospitality": "الفنادق والضيافة",
  "sector.healthcare": "الرعاية الصحية والعيادات",
  "sector.insurance": "التأمين",
  "sector.real_estate": "العقارات",
  "sector.b2b_supply": "مبيعات وتوريد بين الشركات",
  "sector.ecommerce": "التجارة الإلكترونية والشحن",
  "sector.education": "التعليم والدورات",
  "sector.automotive": "السيارات والصيانة",
  "structure.receptionist": "الاستقبال والتوجيه",
  "structure.support": "دعم العملاء",
  "structure.appointment": "المواعيد",
  "structure.sales": "مكالمة مبيعات",
  "structure.lead_qualification": "تأهيل العملاء المحتملين",
  "structure.survey": "استبيان الرضا",
  "structure.reminder": "تذكير",
  "structure.follow_up": "مكالمة متابعة",
  "structure.renewal": "التجديد",
  "templates.panel.title": "القالب",
  "templates.panel.none": "لم يُنشأ هذا الوكيل من قالب.",
  "templates.save": "حفظ كقالب",
  "templates.save.hint": "تصبح إعدادات هذا الوكيل قالبك الخاص؛ لا يراه غيرك ويمكنك إنشاء وكلاء جدد منه.",
  "templates.save.newVersion": "هذا الوكيل مأخوذ من قالبك: الحفظ ينشئ إصداراً جديداً منه.",
  "templates.save.name": "اسم القالب",
  "templates.save.description": "وصف قصير",
  "templates.save.changelog": "ما الذي تغيّر في هذا الإصدار؟",
  "templates.save.button": "حفظ",
  "templates.save.done": "تم حفظ القالب (الإصدار {v}).",
  "templates.update.title": "يتوفر إصدار جديد من القالب: v{v}",
  "templates.update.apply": "الحقول التي سيتم تحديثها: {list}.",
  "templates.update.keep": "الحقول التي غيّرتها وستبقى كما هي: {list}.",
  "templates.update.hint": "لا يتغير الوكيل المباشر من تلقاء نفسه: انشر بعد التطبيق.",
  "templates.update.button": "تطبيق الإصدار v{v}",
  "templates.update.done": "تم تطبيق v{v} (تحديث {n} حقول). لا تنس النشر.",
  "templates.field.mission.goal": "هدف المكالمة",
  "templates.field.mission.successCondition": "معيار النجاح",
  "templates.field.mission.audience": "الجمهور",
  "templates.field.style.tone": "أسلوب الحديث",
  "templates.field.style.maxSentencesPerTurn": "طول الرد",
  "templates.field.facts": "المعلومات المطلوب جمعها",
  "templates.field.boundaries.blockedTopics": "مواضيع يجب تجنبها",
  "templates.field.boundaries.mustNotPromise": "ما لا يجب الوعد به",
  "templates.field.globalIntents.extra": "حالات خاصة",
  "templates.field.statements.extra": "إجابات النشاط",
  "templates.field.routes": "مواضيع التوجيه",
  "error.TEMPLATE_UP_TO_DATE": "الوكيل يستخدم بالفعل أحدث إصدار من القالب.",
  "error.TEMPLATE_NOT_LINKED": "هذا الوكيل غير مرتبط بقالب.",
  "nav.readyAgents": "وكلاء جاهزون",
  "nav.templates": "وكلاء جاهزون",
  "ready.title": "وكلاء جاهزون",
  "ready.subtitle": "اختر وكيلاً جاهزاً حسب اللغة والقطاع واتجاه المكالمة؛ تتم تعبئته بمعلومات نشاطك وإنشاؤه بخطوة واحدة.",
  "ready.toStudio": "أنشئ من الصفر بالمحادثة",
  "ready.loading": "جارٍ قراءة معلومات نشاطك…",
  "ready.goal": "ماذا يفعل الوكيل",
  "ready.collects": "المعلومات التي يجمعها",
  "ready.routes": "المواضيع التي يوجهها",
  "ready.answers": "الإجابات التي يقدمها باسم نشاطك",
  "ready.never": "ما لا يعد به أبداً",
  "ready.name": "اسم الوكيل",
  "ready.contactSource": "من أين تأتي الأرقام التي تتصل بها؟",
  "ready.contactSource.placeholder": "مثال: عملاء تواصلوا معنا سابقاً",
  "ready.contactSource.hint": "إذا سأل العميل \"من أين حصلتم على رقمي؟\" يقول الوكيل هذا. يجب أن يكون صحيحاً، لذلك نطلبه منك.",
  "ready.optional": "اختياري",
  "ready.incomplete": "هذا القالب ينقصه بعض الحقول؛ يرجى إنشاؤه عبر الاستوديو.",
  "ready.create": "إنشاء الوكيل",
  "ready.creating": "جارٍ الإنشاء…",
  "ready.after": "بعد الإنشاء تُجهَّز حزمة المبيعات تلقائياً؛ ثم تختبر وتنشر. يمكنك تغيير كل شيء لاحقاً.",
  "ready.fromStudio": "اختر وكيلاً جاهزاً",
  "ready.fromStudio.hint": "وكلاء جاهزون لقطاعك تُملأ بمعلوماتك؛ بخطوة واحدة دون أسئلة.",
  "error.TEMPLATE_INPUT_MISSING": "هناك معلومات ناقصة لإنشائه.",
  "nav.stats": "الإحصاءات",
  "stats.title": "الإحصاءات",
  "stats.subtitle": "ما قام به وكلاؤك وما حققه لك. تُحتسب المكالمات الحقيقية فقط؛ مكالمات الاختبار غير مشمولة.",
  "stats.period": "الفترة",
  "stats.lastDays": "آخر {n} يوماً",
  "stats.agent": "الوكيل",
  "stats.allAgents": "كل الوكلاء",
  "stats.allDirections": "الواردة + الصادرة",
  "stats.empty": "لا توجد مكالمات حقيقية في هذه الفترة. ابدأ حملة أو اربط رقمك بوكيل.",
  "stats.kpi.calls": "المكالمات",
  "stats.kpi.answered": "تم الرد على {p}%",
  "stats.kpi.talked": "محادثات تمت",
  "stats.kpi.avg": "المتوسط {d} دقيقة",
  "stats.kpi.minutes": "دقائق المحادثة",
  "stats.kpi.minutesNote": "مجموع المكالمات المُجابة",
  "stats.kpi.hot": "عملاء متحمسون",
  "stats.kpi.hotNote": "{p}% من المحادثات · {warm} مهتمون",
  "stats.kpi.callbacks": "معاودات الاتصال",
  "stats.kpi.callbacksNote": "مكالمة تالية متفق عليها",
  "stats.kpi.optOuts": "طلبات عدم الاتصال",
  "stats.kpi.optOutsNote": "{p}% من المُجابة · أُضيفت إلى القائمة",
  "stats.kpi.machine": "البريد الصوتي",
  "stats.kpi.machineNote": "أنهى الوكيل المكالمة فوراً",
  "stats.kpi.mood": "نبرة إيجابية",
  "stats.kpi.moodNote": "{n} محادثات سلبية",
  "stats.daily.title": "المكالمات اليومية ونتائجها",
  "stats.daily.hint": "عدد المكالمات كل يوم ومدى اهتمام العملاء.",
  "stats.showTable": "عرض كجدول",
  "stats.showChart": "عرض كرسم بياني",
  "stats.seg.hot": "متحمس",
  "stats.seg.warm": "مهتم",
  "stats.seg.cold": "غير مهتم",
  "stats.seg.notReached": "لم يتم الوصول",
  "stats.seg.unscored": "غير مُقيَّم",
  "stats.col.day": "اليوم",
  "stats.col.answered": "نسبة الرد",
  "stats.col.avg": "متوسط المدة",
  "stats.funnel.title": "قمع المكالمات",
  "stats.funnel.hint": "من الاتصال حتى الخطوة التالية: كم بقي في كل مرحلة.",
  "stats.funnel.dialed": "تم الاتصال",
  "stats.funnel.answered": "ردّ",
  "stats.funnel.talked": "تحدّث",
  "stats.funnel.interested": "أبدى اهتماماً",
  "stats.funnel.next": "خطوة تالية",
  "stats.funnel.ofFirst": "{p}% ممن تم الاتصال بهم",
  "stats.heat.title": "النشاط حسب اليوم والساعة",
  "stats.heat.hint": "المربعات الأغمق تعني مكالمات أكثر: للصادرة أوقات الرد، وللواردة أكثر الساعات ازدحاماً.",
  "stats.heat.read": "{n} مكالمات، {a} تم الرد",
  "stats.heat.hover": "مرّر فوق مربع لعرض التفاصيل.",
  "stats.agents.title": "حسب الوكيل",
  "stats.topics.title": "مواضيع المتصلين",
  "stats.topics.hint": "المواضيع التي وجّهها وكيل الاستقبال.",
  "stats.dow.1": "الإثنين",
  "stats.dow.2": "الثلاثاء",
  "stats.dow.3": "الأربعاء",
  "stats.dow.4": "الخميس",
  "stats.dow.5": "الجمعة",
  "stats.dow.6": "السبت",
  "stats.dow.7": "الأحد",
  "stats.usage.title": "الاستخدام والتكلفة",
  "stats.usage.rates": "{c} رصيد لكل مكالمة + {m} رصيد لكل دقيقة بدأت (حسب باقتك في Panaryus).",
  "stats.usage.unavailable": "تعذّر الوصول إلى تفاصيل الباقة الآن؛ تُعرض الدقائق المحتسبة فقط.",
  "stats.usage.billable": "الدقائق المحتسبة",
  "stats.usage.billableNote": "{n} مكالمات مُجابة، تُقرَّب الدقائق للأعلى",
  "stats.usage.spent": "الرصيد المستهلك في هذه الفترة",
  "stats.usage.spentNote": "رصيد المكالمات + الدقائق",
  "stats.usage.perHot": "لكل عميل متحمس",
  "stats.usage.perHotNote": "رصيد",
  "stats.usage.perCallback": "لكل معاودة اتصال",
  "stats.usage.perCallbackNote": "رصيد",
  "stats.usage.credits": "الرصيد المتبقي",
  "stats.usage.creditsNote": "في حسابك على Panaryus",
  "stats.usage.plan": "الباقة: {plan} — دقائق المكالمات",
  "stats.usage.minutes": "{used} / {limit} دقيقة",
  "stats.usage.unlimited": "{used} دقيقة (غير محدود)",
  "stats.usage.near": "تم استخدام أكثر من 90% من دقائق باقتك. تتوقف المكالمات عند نفادها؛ فكّر في الترقية.",
  "stats.campaigns.title": "مقارنة الحملات",
  "stats.campaigns.hint": "أي قائمة ووكيل جلبا أكثر العملاء اهتماماً مقابل الرصيد المستهلك. نسبة المتحمسين من المحادثات.",
  "stats.campaigns.name": "الحملة",
  "stats.campaigns.list": "تم الوصول / القائمة",
  "stats.campaigns.hotRate": "عملاء متحمسون",
  "stats.campaigns.credits": "الرصيد",
  "stats.campaigns.best": "الأفضل",
  "create.hero.title": "هيا ننشئ الوكيل المناسب لك بسهولة",
  "ready.hero.body": "اختر وكيلاً جاهزاً لقطاعك؛ يُملأ بمعلومات نشاطك ويكون جاهزاً بخطوة واحدة. لم تجد ما تبحث عنه؟ اكتب ما تحتاجه وسنجده معاً.",
  "studio.hero.body": "أخبرنا بما تحتاجه؛ يسأل الذكاء الاصطناعي خطوة بخطوة وننشئ وكيلك معاً. أسرع: اختر وكيلاً جاهزاً لقطاعك.",
  "studio.hero.start": "ابدأ الإنشاء بالمحادثة",
  "ready.finder.open": "لم تجده؟ لنجد الحل بسرعة",
  "ready.finder.title": "لنجد الوكيل المناسب",
  "ready.finder.ask": "ماذا يجب أن يفعل وكيلك؟ اكتب بكلماتك، مثلاً: \"يستقبل المتصلين بعيادة الأسنان ويحجز المواعيد\" أو \"يتصل بالعملاء السابقين ليخبرهم بعرضنا الجديد\".",
  "ready.finder.placeholder": "ماذا تريد أن يفعل الوكيل؟",
  "ready.finder.use": "اختر هذا الوكيل",
  "ready.finder.noneFit": "لا يناسبك أيٌّ منها؟",
  "ready.finder.noMatch": "لا يوجد وكيل جاهز مناسب؛ لننشئ وكيلاً خاصاً لك.",
  "ready.finder.custom": "أنشئ وكيلاً خاصاً بالمحادثة",
  "ready.finder.close": "إغلاق",
  "nav.group.platform": "المنصة",
  "nav.templateNeeds": "احتياجات القوالب",
  "nav.needs": "احتياجات القوالب",
  "platform.needs.title": "احتياجات القوالب",
  "platform.voice.title": "الصوت التركي (EMA)",
  "platform.voice.on": "يعمل",
  "platform.voice.off": "متوقف",
  "platform.voice.unreachable": "لا يمكن الوصول إليه",
  "platform.voice.load": "قيد الاستخدام {active} من {max} · تمت قراءة {served} · رفض بسبب الانشغال {busy}",
  "platform.voice.lastHour": "آخر ساعة: {emaCalls} مكالمة على EMA، انتقلت {fellBack} إلى الصوت الاحتياطي ({fallbacks} انتقال) · أخطاء الصوت في كل المكالمات: {failed}",
  "platform.needs.subtitle": "ما طلبته الأنشطة عبر \"لم تجده؟\" — لجميع الأنشطة، تسميات وأعداد فقط (دون نشاط أو نص). الطلبات دون قالب مناسب أولاً: القوالب التالية التي يجب كتابتها.",
  "platform.needs.empty": "لم يُستخدم الباحث في هذه الفترة.",
  "platform.needs.industry": "القطاع",
  "platform.needs.callType": "نوع المكالمة",
  "platform.needs.requests": "الطلبات",
  "platform.needs.businesses": "الأنشطة",
  "platform.needs.noMatch": "لا وكيل جاهز",
  "platform.needs.choseTemplate": "اختار اقتراحاً",
  "platform.needs.choseCustom": "أنشأ خاصاً",
  "platform.needs.write": "يجب كتابة قالب",
  "platform.needs.hint": "\"يجب كتابة قالب\": طلبه نشاطان على الأقل ولم يوجد وكيل جاهز 3 مرات على الأقل. القطاع ونوع المكالمة تسميات إنجليزية قصيرة من الذكاء الاصطناعي.",
  "error.PLATFORM_ADMIN_ONLY": "هذه الشاشة لمشغلي المنصة فقط.",
  "agent.tab.readiness": "الجاهزية",
  "readiness.title": "جاهزية الوكيل: {score}%",
  "readiness.subtitle": "الأسئلة التي سيطرحها المتصلون وبعض الإعدادات. كلما أجبت أكثر، أجاب الوكيل بنفسه أكثر؛ وإلا يعرض معاودة الاتصال.",
  "readiness.publishNote": "تُحفظ الإجابات في المسودة وتُستخدم في المكالمات الحية بعد النشر. يعمل الوكيل حتى لو تركتها فارغة.",
  "readiness.suggest.none": "هذا الوكيل لم يُنشأ من قالب جاهز، لذا لا توجد قائمة أسئلة. يمكن للذكاء الاصطناعي اقتراح أسئلة لنشاطك.",
  "readiness.suggest.more": "يمكنك أيضًا إضافة أسئلة أخرى خاصة بنشاطك.",
  "readiness.suggest.button": "دع الذكاء الاصطناعي يقترح أسئلة",
  "readiness.suggest.running": "جارٍ تجهيز الأسئلة…",
  "readiness.group.missing": "ناقص ({n})",
  "readiness.group.done": "مكتمل ({n})",
  "readiness.group.dismissed": "لا ينطبق ({n})",
  "readiness.impact.high": "مهم جدًا",
  "readiness.impact.medium": "مهم",
  "readiness.impact.low": "مفيد",
  "readiness.fill": "املأ بالذكاء الاصطناعي",
  "readiness.edit": "تعديل",
  "readiness.dismiss": "لا ينطبق علينا",
  "readiness.undismiss": "تراجع",
  "readiness.setting.go": "إعداد",
  "readiness.setting.hours.title": "ساعات العمل والمنطقة الزمنية",
  "readiness.setting.hours.why": "يحدد بها الوكيل أوقات الاتصال والإجابة عن \"هل أنتم مفتوحون\" ومواعيد معاودة الاتصال.",
  "readiness.setting.voice.title": "صوت الوكيل",
  "readiness.setting.voice.why": "الصوت المناسب لعلامتك يزيد ثقة المتصل ومدة المكالمة.",
  "readiness.setting.transfers.title": "أرقام التحويل",
  "readiness.setting.transfers.why": "عندما يطلب المتصل موظفًا يحوّل الوكيل المكالمة إلى هذه الأرقام؛ وبدونها يكتفي بتسجيل ملاحظة.",
  "readiness.setting.routing_unreachable.title": "نشر الوكلاء الذين تذهب إليهم المواضيع",
  "readiness.setting.routing_unreachable.why": "الموضوع المحوَّل إلى وكيل غير منشور لا يصل إليه أبدًا، فيكتفي الوكيل بتدوين رسالة. انشر ذلك الوكيل أو اختر وجهة أخرى.",
  "readiness.setting.routing_callback.title": "معاودة الاتصال للمواضيع التي تُدوَّن فيها رسالة",
  "readiness.setting.routing_callback.why": "في هذه المواضيع يدوّن الوكيل رسالة. فعّل معاودة الاتصال حتى يتفق أيضًا مع المتصل على موعد لمعاودة الاتصال.",
  "readiness.setting.contact_source.title": "من أين حصلتم على جهات الاتصال",
  "readiness.setting.contact_source.why": "\"من أين حصلتم على رقمي؟\" هو أكثر سؤال في المكالمات الصادرة؛ والوكيل الذي لا يجيب بوضوح يفقد الثقة.",
  "readiness.card.title": "جاهزية الوكيل {score}%",
  "readiness.card.open": "أكمل المعلومات الناقصة",
  "readiness.card.high": "{n} معلومات مهمة جدًا ناقصة (المجموع {total}). الوكيل يعمل لكنه سيعرض معاودة الاتصال في هذه الأسئلة.",
  "readiness.card.some": "{n} معلومات ناقصة. كلما أكملتها أجاب الوكيل بنفسه أكثر.",
  "readiness.assist.placeholder": "اكتب الإجابة بكلماتك (مثل الأسعار أو الساعات أو الشروط)…",
  "readiness.assist.draft": "ما سيقوله الوكيل",
  "readiness.assist.draftPlaceholder": "يمكنك أيضًا كتابتها هنا بنفسك.",
  "readiness.assist.draftHint": "يستخدم الوكيل هذه الجملة كما هي. لا يخترع الذكاء الاصطناعي أرقامًا أو معلومات لم تُعطَ له.",
  "readiness.assist.save": "حفظ",
  "overview.att.readiness": "{name}: {n} معلومات مهمة ناقصة",
  "overview.att.readiness.body": "الوكيل يعمل (الجاهزية {score}%) لكنه لا يستطيع إعطاء إجابة واضحة لهذه الأسئلة.",
  "overview.att.readiness.cta": "أكمل المعلومات الناقصة",
  "readiness.assist.opening": "لم أجد شيئًا عن هذا في معلوماتك. عندما يسأل المتصل \"{question}\"، ماذا يجب أن تكون الإجابة؟ اكتبها باختصار بكلماتك وسأحوّلها إلى ما سيقوله الوكيل.",
  "stats.unanswered.title": "أسئلة لم يستطع الوكيل الإجابة عنها",
  "stats.unanswered.hint": "أسئلة طرحها العملاء في مكالمات حقيقية ولم يُجب الوكيل عنها بوضوح. أضف الإجابة وسيتولاها الوكيل في المرة القادمة.",
  "stats.unanswered.open": "{n} أسئلة بانتظار إجابة",
  "stats.unanswered.empty": "لا يوجد بعد. تُجمع هنا مع انتهاء المكالمات الجديدة.",
  "stats.unanswered.question": "السؤال",
  "stats.unanswered.calls": "المكالمات",
  "stats.unanswered.lastCall": "افتح آخر مكالمة",
  "stats.unanswered.add": "أضف الإجابة",
  "stats.unanswered.done": "أُضيفت الإجابة",
  "stats.unanswered.why": "سأل العملاء هذا {n} مرات في مكالمات حقيقية ولم يستطع الوكيل الإجابة. بعد إضافة الإجابة يتولاها الوكيل بنفسه.",
  "stats.endings.title": "أين انتهت المكالمات؟",
  "stats.endings.hint": "المرحلة التي انتهت فيها المكالمات وعدد من أغلق فيها العميل الخط. المرحلة التي يغلق فيها أكثر العملاء هي ما يجب تحسينه.",
  "stats.endings.empty": "لا توجد مكالمات طويلة كافية في هذه الفترة.",
  "stats.endings.row": "{n} مكالمات · أغلق العميل {c} · مهتم {i}",
  "stats.endings.hungUp": "أغلق العميل {n}",
  "stats.stage.opening": "الافتتاح",
  "stats.stage.discovery": "فهم الاحتياج",
  "stats.stage.pitch": "العرض",
  "stats.stage.objection": "الاعتراض",
  "stats.stage.closing": "الختام",
  "stats.stage.ended": "انتهت",
  "stats.endings.advice.opening": "أغلق {n} عملاء أثناء الافتتاح. جملة أولى أقصر توضح سبب الاتصال تُحدث عادةً أكبر فرق.",
  "stats.endings.advice.discovery": "أغلق {n} عملاء أثناء الأسئلة. جرّب أسئلة أقل وأقصر.",
  "stats.endings.advice.pitch": "أغلق {n} عملاء أثناء العرض. جرّب تقديمه بفائدة واحدة واضحة وحدّث حزمة المبيعات.",
  "stats.endings.advice.objection": "أغلق {n} عملاء بعد اعتراض. أضف إجابات جاهزة للاعتراضات الشائعة في حزمة المبيعات.",
  "stats.cb.title": "وعود معاودة الاتصال",
  "stats.cb.hint": "هل وفى الوكيل بوعود معاودة الاتصال؟ هل اتصل في الوقت ووصل إلى العميل؟",
  "stats.cb.empty": "لا توجد وعود معاودة اتصال في هذه الفترة.",
  "stats.cb.summary": "{n} وعود · {onTime} من {placed} مكالمات في الوقت ({p}%)",
  "stats.cb.reached": "اتصل ووصل",
  "stats.cb.notReached": "اتصل ولم يُرد",
  "stats.cb.team": "أنجزه فريقك",
  "stats.cb.waiting": "بانتظار موعده",
  "stats.cb.late": "متأخر",
  "stats.cb.failed": "تعذّر الاتصال",
  "stats.cb.manual": "يُتصل يدويًا",
  "stats.cb.reached.hint": "اتصل الوكيل في الموعد وأجاب العميل.",
  "stats.cb.notReached.hint": "اتصل الوكيل لكن العميل لم يُجب أو ردّ البريد الصوتي.",
  "stats.cb.team.hint": "وضع فريقك علامة \"تم\".",
  "stats.cb.waiting.hint": "لم يحن موعده بعد؛ سيتصل الوكيل تلقائيًا.",
  "stats.cb.late.hint": "تجاوز موعده بأكثر من 10 دقائق ولم يُتصل.",
  "stats.cb.failed.hint": "لم يستطع الوكيل إجراء المكالمة؛ السبب أدناه.",
  "stats.cb.manual.hint": "وعود لا يمكن الاتصال بها تلقائيًا (مثل عدم تحديد وقت)؛ يجب أن يتصل فريقك.",
  "stats.cb.open": "افتح المكالمة",
  "stats.cb.error.PHONE_NOT_E164": "صيغة الرقم غير معروفة",
  "stats.cb.error.DO_NOT_CALL": "طلب العميل عدم الاتصال",
  "stats.cb.error.AGENT_NOT_PUBLISHED": "الوكيل غير منشور",
  "stats.cb.error.OUTSIDE_HOURS": "خارج ساعات العمل",
  "stats.cb.error.ORIGINATE_FAILED": "تعذّر على الخط إجراء المكالمة",
  "stats.cb.error.BILLING_PRINCIPAL_MISSING": "بيانات الحساب ناقصة",
  "stats.cb.error.other": "تعذّر الاتصال",
  "agent.tab.offerings": "المنتجات",
  "offerings.title": "المنتجات والخدمات",
  "offerings.subtitle": "ما يعرضه الوكيل في المكالمات. الترتيب هو الأولوية: يعرض الوكيل أول عنصر مناسب.",
  "offerings.suggest": "دع الذكاء الاصطناعي يقترح من معلوماتي",
  "offerings.suggesting": "جارٍ قراءة معلوماتك…",
  "offerings.rule.order": "يُعرض العنصر الأعلى أولًا؛ غيّر الترتيب بالأسهم.",
  "offerings.rule.outbound": "في المكالمات الصادرة يسأل الوكيل أولًا باختصار عن الحاجة، ثم يعرض المناسب، وينتقل للتالي إن لم يوجد اهتمام. بحد أقصى 3 في المكالمة.",
  "offerings.rule.inbound": "في المكالمات الواردة يتحدث عما يسأل عنه المتصل، ويقترح عنصرًا آخر فقط إن كان مناسبًا وقرب النهاية.",
  "offerings.rule.truth": "لا يقول الوكيل إلا ما هو مكتوب هنا؛ ولا يختلق سعرًا أو شرطًا.",
  "offerings.found": "تم العثور على {n} منتج/خدمة — اختر ما تريد إضافته",
  "offerings.none": "لم يُعثر على منتجات أو خدمات في معلوماتك. يمكنك إضافتها يدويًا.",
  "offerings.suggest.hint": "يقترح الذكاء الاصطناعي فقط ما في عقل نشاطك التجاري؛ راجع واحفظ.",
  "offerings.addPicked": "أضف {n}",
  "offerings.empty": "لا توجد منتجات بعد. دع الذكاء الاصطناعي يقترحها أو أضفها يدويًا.",
  "offerings.rank": "الأولوية {n}",
  "offerings.summary.missing": "الوصف ناقص",
  "offerings.up": "نقل لأعلى",
  "offerings.down": "نقل لأسفل",
  "offerings.name": "الاسم",
  "offerings.summary": "ما هو (جملة واحدة)",
  "offerings.summary.hint": "بكلمات يومية؛ يقوله الوكيل بأسلوبه.",
  "offerings.benefits": "الفوائد (واحدة في كل سطر، حتى 3)",
  "offerings.benefits.hint": "مكسب ملموس للعميل، مثل الوقت أو المال أو السهولة.",
  "offerings.fits": "لمن / لأي حاجة يناسب",
  "offerings.terms": "السعر أو الشروط (اختياري)",
  "offerings.terms.hint": "إذا كتبت سعرًا أو شرطًا يقوله الوكيل كما هو؛ وإن تركته فارغًا يقول إن التفصيل غير متوفر.",
  "offerings.remove": "احذف هذا العنصر",
  "offerings.add": "أضف منتجًا",
  "offerings.new": "منتج جديد",
  "offerings.unsaved": "تغييرات غير محفوظة",
  "offerings.publishNote": "بعد الحفظ، انشر الوكيل ليُستخدم في المكالمات الحية.",
  "campaigns.focus": "منتجات مميزة",
  "campaigns.focus.hint": "العناصر المحددة تُعرض أولًا في هذه الحملة؛ والباقي حسب ترتيب الوكيل.",
  "campaigns.focus.none": "لا توجد قائمة منتجات لهذا الوكيل؛ أضفها من تبويب المنتجات في صفحة الوكيل.",
  "campaigns.focus.default": "ترتيب الوكيل",
  "stats.offerings.title": "الاهتمام بالمنتجات",
  "stats.offerings.hint": "المنتجات والخدمات التي عرضها الوكلاء في المكالمات، وهل أبدى العملاء اهتمامًا أم لا.",
  "stats.offerings.item": "المنتج / الخدمة",
  "stats.offerings.presented": "عُرض",
  "stats.offerings.interest": "الاهتمام",
  "stats.offerings.cold": "غير مهتم",
  "offerings.saved": "تم حفظ المنتجات. انشر الوكيل لاستخدامها في المكالمات الحية.",
  "offerings.incomplete": "للحفظ، يجب أن يكون لكل منتج اسم ووصف: {names}",
  "greeting.title": "الافتتاح",
  "greeting.hint": "كيف يفتتح الوكيل المكالمة؟ تحية قصيرة أولًا ثم انتظار الرد تبدو أكثر طبيعية.",
  "greeting.full": "افتتاح كامل في جملة واحدة",
  "greeting.full.hint": "التحية والتعريف والإفصاحات المطلوبة وسبب الاتصال في الجملة الأولى.",
  "greeting.greet": "التحية أولًا",
  "greeting.greet.hint": "الجملة الأولى تحية فقط؛ التعريف والإفصاحات بعد رد العميل.",
  "greeting.lines": "جمل التحية (واحدة في كل سطر، حتى 5)",
  "greeting.lines.hint": "تُستخدم واحدة في كل مكالمة بالتناوب. اكتب {brand} لإدراج اسم نشاطك.",
  "greeting.suggestions": "اقتراحات:",
  "greeting.legal": "يُذكر الإفصاح عن الذكاء الاصطناعي والتسجيل في الجملة الثانية للوكيل عند تعريفه بنفسه.",
  "offerings.counts": "{v} نوع · {q} سؤال · {x} اعتراض",
  "offerings.details.title": "الأنواع وحزمة المنتج",
  "offerings.details.hint": "عندما يهتم العميل، يقترح الوكيل نوعًا أو نوعين مناسبين ويجيب عن الأسئلة والاعتراضات بالإجابات هنا.",
  "offerings.details.fill": "املأ بالذكاء الاصطناعي",
  "offerings.details.found": "تم العثور على {n} اقتراح — اختر ما تريد إضافته",
  "offerings.details.none": "لم يُعثر على اقتراحات لهذا المنتج في معلوماتك. يمكنك الإضافة يدويًا.",
  "offerings.variant": "نوع",
  "offerings.faq": "سؤال",
  "offerings.objection": "اعتراض",
  "offerings.variants": "الأنواع",
  "offerings.variant.name": "الاسم (مثل العلامة أو الطراز أو الباقة)",
  "offerings.variant.summary": "وصف قصير",
  "offerings.variant.terms": "السعر / الشرط",
  "offerings.variant.add": "أضف نوعًا",
  "offerings.faqs": "الأسئلة الشائعة",
  "offerings.faq.q": "سؤال العميل",
  "offerings.faq.a": "إجابة الوكيل",
  "offerings.faq.add": "أضف سؤالًا",
  "offerings.objections": "الاعتراضات",
  "offerings.objection.q": "اعتراض العميل",
  "offerings.objection.a": "إجابة الوكيل",
  "offerings.objection.add": "أضف اعتراضًا",
  "offerings.row.remove": "إزالة",
  "nav.aiCalls": "المكالمات واستخدام الذكاء الاصطناعي",
  "platform.calls.title": "المكالمات واستخدام الذكاء الاصطناعي",
  "platform.calls.subtitle": "كل مكالمات كل الأنشطة: نماذج الذكاء الاصطناعي المستخدمة وعدد الرموز والتكلفة التقديرية. انقر على مكالمة للتفاصيل.",
  "platform.calls.kind.all": "الكل",
  "platform.calls.kind.real": "المكالمات الحقيقية",
  "platform.calls.kind.room": "غرفة الاختبار",
  "platform.calls.room": "غرفة الاختبار",
  "platform.calls.tenantFilter": "معرف النشاط (مثل ten_pu_5432)",
  "platform.calls.onPage": "في هذه الصفحة",
  "platform.calls.inputTokens": "رموز الإدخال",
  "platform.calls.outputTokens": "رموز الإخراج",
  "platform.calls.cached": "من الذاكرة المؤقتة",
  "platform.calls.cost": "التكلفة التقديرية",
  "platform.calls.empty": "لا توجد مكالمات.",
  "platform.calls.date": "التاريخ",
  "platform.calls.business": "النشاط",
  "platform.calls.agent": "الوكيل",
  "platform.calls.customer": "العميل",
  "platform.calls.type": "النوع",
  "platform.calls.duration": "المدة",
  "platform.calls.turns": "الأدوار",
  "platform.calls.models": "النماذج",
  "platform.calls.model": "النموذج",
  "platform.calls.tokens": "الرموز (إدخال/إخراج)",
  "platform.calls.hint": "التكلفة تقديرية من جدول الأسعار (templates/defaults/llm-prices.json)؛ SuperGrok اشتراك لذا 0. المكالمات قبل 28.09.2026 بلا سجل استخدام.",
  "platform.calls.newer": "→ الأحدث",
  "platform.calls.older": "الأقدم ←",
  "platform.calls.back": "العودة إلى المكالمات",
  "platform.calls.modelCalls": "استدعاءات النموذج",
  "platform.calls.summary": "الملخص",
  "platform.calls.scenario": "سيناريو الاختبار",
  "platform.calls.modelsUsed": "النماذج المستخدمة",
  "platform.calls.noUsage": "لا يوجد سجل استخدام لهذه المكالمة (المكالمات قبل 28.09.2026 لا تحتوي عليه).",
  "platform.calls.job": "المهمة",
  "platform.calls.avgTime": "متوسط الوقت",
  "platform.calls.unpriced": "لا يوجد سعر في الجدول لـ: {models}",
  "platform.calls.conversation": "المحادثة",
  "platform.calls.conversationHint": "لكل دور: ما سمعه الوكيل وقاله، ومدى سرعة بدئه بالكلام، ورموز الدور.",
  "platform.calls.noTurns": "لا توجد أدوار مسجلة.",
  "platform.calls.firstWord": "أول كلمة {s} ث",
  "platform.calls.turnTokens": "الرموز {in} ← {out} (مخزنة {cached})",
  "platform.calls.critics": "تدخلت الفحوصات: {list}",
  "platform.calls.role.conductor": "الوكيل (التحدث)",
  "platform.calls.role.test_agent": "وكيل الاختبار",
  "platform.calls.role.judge": "فحوصات أثناء المكالمة",
  "platform.calls.role.bridge": "الحشو",
  "platform.calls.role.simulator": "عميل الاختبار",
  "platform.calls.role.analyst": "تحليل المكالمة",
  "eval.title": "بطاقة تقييم المكالمة (حَكَم الذكاء الاصطناعي)",
  "eval.unsure": "راجِع",
  "eval.unsureHint": "الحَكَم غير متأكد من هذه الإجابة؛ راجع النص.",
  "eval.score.opening": "الافتتاح",
  "eval.score.discovery": "فهم الاحتياج",
  "eval.score.objection_handling": "التعامل مع الاعتراضات",
  "eval.score.closing": "الإغلاق / الخطوة التالية",
  "eval.score.clarity": "الوضوح والإيجاز",
  "eval.flag.said_recording_notice": "تم ذكر إشعار التسجيل",
  "eval.flag.said_ai_disclosure": "تم الإفصاح عن الذكاء الاصطناعي",
  "eval.flag.agent_missed_question": "بقي سؤال بلا إجابة",
  "eval.flag.agent_repeated": "كرر الوكيل نفسه",
  "eval.flag.agent_ended_early": "أُنهيت مبكراً",
  "eval.flag.alert_complaint": "شكوى / عميل غاضب",
  "eval.choice.outcome": "النتيجة",
  "eval.choice.loss_reason": "سبب الخسارة",
  "eval.choice.drop_stage": "أين تعثرت",
  "eval.choice.sentiment_end": "المزاج في النهاية",
  "eval.choice.outcome.next_step": "تم الاتفاق على خطوة تالية",
  "eval.choice.outcome.callback": "معاودة الاتصال",
  "eval.choice.outcome.interested": "مهتم بلا خطوة",
  "eval.choice.outcome.not_interested": "غير مهتم",
  "eval.choice.outcome.opted_out": "لا يريد الاتصال",
  "eval.choice.outcome.no_conversation": "لا محادثة",
  "eval.choice.outcome.unclear": "غير واضح",
  "eval.choice.loss_reason.price_or_terms": "السعر / الشروط",
  "eval.choice.loss_reason.has_provider": "لديه مورد بالفعل",
  "eval.choice.loss_reason.timing": "التوقيت",
  "eval.choice.loss_reason.not_decision_maker": "ليس صاحب القرار",
  "eval.choice.loss_reason.no_need": "لا حاجة",
  "eval.choice.loss_reason.distrust": "عدم ثقة",
  "eval.choice.loss_reason.agent_problem": "مشكلة من الوكيل",
  "eval.choice.loss_reason.other": "أخرى",
  "eval.choice.loss_reason.not_applicable": "—",
  "eval.choice.drop_stage.opening": "الافتتاح",
  "eval.choice.drop_stage.discovery": "أسئلة الاحتياج",
  "eval.choice.drop_stage.presentation": "العرض",
  "eval.choice.drop_stage.objection": "السؤال / الاعتراض",
  "eval.choice.drop_stage.closing": "الإغلاق",
  "eval.choice.drop_stage.none": "لم تتعثر",
  "eval.choice.sentiment_end.positive": "إيجابي",
  "eval.choice.sentiment_end.neutral": "محايد",
  "eval.choice.sentiment_end.negative": "سلبي",
  "eval.questions": "أسئلة العميل (أُجيب {a}/{n})",
  "eval.answered": "أُجيب",
  "eval.notAnswered": "بلا إجابة",
  "eval.objection": "اعتراض",
  "quality.title": "جودة المكالمات",
  "quality.subtitle": "بعد كل مكالمة يقيّمها حَكَم ذكاء اصطناعي (JEV): البطاقة والقواعد والنتيجة والأسئلة واستخدام الحقيبة.",
  "quality.source.real": "المكالمات الحقيقية",
  "quality.source.room": "غرفة الاختبار",
  "quality.empty": "لا توجد مكالمات مقيّمة في هذه الفترة.",
  "quality.emptyReal": "لا يتم تقييم المكالمات الحقيقية بعد (يبدأ عند تفعيل مدير المنصة). يمكنك رؤية مكالمات غرفة الاختبار.",
  "quality.scorecard": "متوسط البطاقة ({n} مكالمة)",
  "quality.rules": "القواعد والأخطاء",
  "quality.lossReasons": "لماذا خسرنا",
  "quality.noLoss": "لا خسائر.",
  "quality.dropStage": "أين تعثرت",
  "quality.questions": "أسئلة العملاء ({n}، أُجيب {p}%)",
  "quality.questionsHint": "بلا إجابة: أسئلة لم يعرفها الوكيل أو تهرّب منها. أضف الإجابة إلى حقيبة المنتج أو عقل النشاط ليجيب الوكيل في المرة القادمة.",
  "quality.allAnswered": "تمت الإجابة على كل الأسئلة.",
  "quality.openCall": "افتح المكالمة",
  "quality.kit": "استخدام حقيبة المنتج",
  "quality.kitHint": "أي عنصر من الحقيبة طابق سؤال العميل. العناصر غير المستخدمة وغير المجابة مُعلَّمة.",
  "quality.kitItem": "العنصر",
  "quality.kitKind": "النوع",
  "quality.kitUsed": "الاستخدام",
  "quality.kitUnanswered": "بلا إجابة",
  "quality.neverUsed": "أبداً",
  "quality.kind.offering": "منتج",
  "quality.kind.faq": "سؤال شائع",
  "quality.kind.objection": "اعتراض",
  "voice.engine.title": "مصدر الصوت",
  "voice.engine.hint": "أي نظام يُنتج صوت الوكيل. إذا لم يستجب CenterVoice يُنطق الكلام تلقائياً بالصوت القياسي.",
  "voice.engine.standard": "الصوت القياسي (ElevenLabs)",
  "voice.engine.standard.hint": "اختيار من مكتبة الأصوات، سرعة الكلام",
  "voice.engine.self_hosted": "CenterVoice",
  "voice.engine.self_hosted.hint": "محرك الصوت الخاص بنا؛ اختيار الصوت وسرعة الكلام",
  "voice.engine.ema": "CenterVoice التركية (EMA)",
  "voice.engine.ema.hint": "صوتنا التركي الخاص؛ للمكالمات باللغة التركية فقط. في اللغات الأخرى أو إذا لم يستجب، يكمل الصوت الاحتياطي بقية المكالمة.",
  "voice.ema.sample": "عينة الصوت التركي",
  "voice.backup.title": "الصوت الاحتياطي",
  "voice.backup.hint": "إذا تعذّر على الصوت الرئيسي (EMA أو صوت المكتبة) نطق جملة، تستمر المكالمة بهذا الصوت. وعندما تكون أصوات المكتبة متوقفة يكون هو الصوت القياسي أيضًا. اختر صوتًا من جنس صوت الوكيل نفسه.",
  "voice.backup.platformDefault": "الافتراضي في المنصة",
  "platform.calls.estimated": "{n} تقديري",
  "platform.calls.estimatedHint": "\"تقديري\": طلبات بدأها الوكيل مبكراً وتُركت عندما واصل العميل الكلام. لا يرسل المزوّد عدد رموزها لكنه يحتسب المدخلات؛ قُدّرت من طول الطلب بالمعدل المقاس في المكالمة نفسها.",
  "voice.engine.defaultVoice": "الصوت الافتراضي",
  "platform.calls.warn.voice": "صوت احتياطي {n}×",
  "platform.calls.warn.voiceHint": "بعض الجمل في هذه المكالمة نُطقت بالصوت الاحتياطي بدلاً من صوت الوكيل (أو لم تُنطق).",
  "platform.calls.warn.silence": "صمت {s} ث",
  "platform.calls.warn.silenceHint": "بقي الوكيل صامتاً هذه المدة قبل الرد.",
  "calls.cost.title": "الاستخدام والتكلفة (تقديري)",
  "calls.cost.service": "الخدمة",
  "calls.cost.used": "ما استُخدم",
  "calls.cost.cost": "تقديري",
  "calls.cost.total": "الإجمالي",
  "calls.cost.note": "تقدير من أسعار الوحدة وليس فاتورة. يظهر للجميع أثناء التطوير، ولاحقاً للمسؤولين فقط.",
  "calls.cost.ai": "نماذج الذكاء الاصطناعي",
  "calls.cost.tts": "الصوت (كلام الوكيل)",
  "calls.cost.stt": "الاستماع (صوت ← نص)",
  "calls.cost.line": "خط الهاتف",
  "calls.cost.tokens": "{calls} طلب · {in} إدخال ({cached} من الذاكرة) · {out} إخراج",
  "calls.cost.chars": "{engine} · {chars} حرف · ~{credits} رصيد",
  "calls.cost.minutes": "{minutes} دقيقة × {streams} تدفق",
  "calls.cost.lineMinutes": "{minutes} دقيقة",
  "calls.cost.unpriced": "نموذج بلا سعر: {models}",
  "calls.cost.engine.standard": "ElevenLabs",
  "calls.cost.engine.self_hosted": "CenterVoice",
  "platform.calls.role.decider": "حكم الذكاء الاصطناعي (JEV)",
  "contacts.import.empty": "الصق الصفوف أو اختر ملف CSV.",
  "contacts.form.title": "إضافة شخص",
  "contacts.form.editTitle": "تعديل الشخص",
  "contacts.form.hint": "يستخدم الوكيل الاسم والمسمى والشركة أثناء المكالمة، فتصبح كل مكالمة شخصية. الهاتف فقط إلزامي.",
  "contacts.form.save": "حفظ",
  "contacts.form.cancel": "إلغاء",
  "contacts.form.edit": "تعديل",
  "contacts.optional": "اختياري",
  "contacts.field.name": "الاسم الكامل",
  "contacts.field.name.placeholder": "مثال: سارة أحمد",
  "contacts.field.phone": "الهاتف",
  "contacts.field.phone.hint": "مع رمز الدولة (+966…). حفظ الرقم نفسه مرة أخرى يحدّث البيانات.",
  "contacts.field.title": "المسمى",
  "contacts.field.title.placeholder": "مثال: صيدلي، مدير المشتريات",
  "contacts.field.company": "الشركة",
  "contacts.field.city": "المدينة",
  "contacts.field.email": "البريد الإلكتروني",
  "contacts.field.note": "ملاحظة",
  "contacts.field.note.hint": "معلومة قصيرة يجب أن يعرفها الوكيل (مثال: \"سأل عن الأسعار الشهر الماضي\").",
  "call.fromContacts": "اختر من جهات الاتصال",
  "call.picked": "تم الاختيار: {name} — سيعرف الوكيل من يتصل به.",
  "error.CALL_COUNTRY_NOT_ALLOWED": "لا يمكن الاتصال بأرقام هذه الدولة: للأمان يُسمح فقط بأرقام دولة خطك. تواصل مع الدعم إذا احتجت دولة أخرى.",
  "error.TOO_MANY_ACTIVE_CALLS": "تم الوصول إلى الحد الأقصى للمكالمات المتزامنة. حاول مرة أخرى عند انتهاء إحداها.",
  "error.DAILY_CALL_LIMIT": "تم الوصول إلى حد المكالمات اليومية من اللوحة. حاول غداً أو استخدم حملة.",
  "agent.label.title": "اسم اللوحة",
  "agent.label.placeholder": "مثال: صادر — وكيل التسويق (عربي)",
  "agent.label.hint": "يظهر لك في اللوحة فقط، ولا يُقال في المكالمة.",
  "agent.label.speaking": "الاسم في المكالمات: {name}",
  "agent.label.none": "لا يوجد اسم للوحة.",
  "agent.label.add": "إضافة اسم للوحة",
  "agent.label.edit": "تغيير اسم اللوحة",
  "webcall.start": "تحدث من المتصفح",
  "webcall.hint": "بالميكروفون، بدون خط هاتف؛ لا تُحتسب دقائق. يُنصح بسماعات.",
  "webcall.connecting": "جارٍ الاتصال…",
  "webcall.live": "في المكالمة",
  "webcall.hangup": "إنهاء",
  "webcall.error.MIC_DENIED": "لم يُمنح إذن الميكروفون. اسمح بالميكروفون من شريط عنوان المتصفح.",
  "webcall.error.WEB_CALL_CONNECTION": "تعذّر إنشاء اتصال الصوت.",
  "webcall.mute": "كتم",
  "webcall.unmute": "إلغاء الكتم",
  "webcall.again": "ابدأ من جديد",
  "webcall.close": "إغلاق",
  "webcall.status.agent": "الوكيل يتحدث…",
  "webcall.status.user": "يستمع إليك",
  "webcall.status.listening": "يستمع",
  "webcall.status.muted": "الميكروفون مغلق",
  "webcall.status.ended": "انتهت المكالمة",
  "room.mode.sim": "مع عميل افتراضي",
  "room.mode.me": "سأتحدث بنفسي",
  "room.mode.me.hint": "تحدث مع الوكيل بالميكروفون، بدون خط هاتف. تُسجَّل المكالمة ويُقيَّم أداؤها كأي مكالمة؛ لا تُحتسب دقائق. يُنصح بسماعات.",
  "webcall.begin": "ابدأ المكالمة",
  "webcall.section": "جرّب بالصوت (الميكروفون)",
  "webcall.section.text": "جرّب بالكتابة",
  "sms.title": "حساب الرسائل النصية",
  "sms.hint": "الرسائل التي يرسلها الوكيل من المكالمة (ملخص، رابط) تُرسل من حساب الرسائل الخاص بشركتك، ويحاسبك مزودك. تُرسل فقط إلى رقم المكالمة وعند طلب العميل.",
  "sms.none": "لا يوجد حساب رسائل مرتبط.",
  "sms.connect": "ربط حساب رسائل",
  "sms.provider.verimor": "Verimor SMS",
  "sms.username": "اسم مستخدم API",
  "sms.username.hint": "لدى Verimor عادةً رقم حسابك بدءًا برمز الدولة (مثل 908501234567).",
  "sms.password": "كلمة مرور API",
  "sms.password.hint": "كلمة المرور المحددة في إعدادات API للرسائل لدى المزود (وليست كلمة مرور الدخول).",
  "sms.sender": "اسم المرسل",
  "sms.sender.hint": "أحد أسماء المرسل المعتمدة؛ إذا تُرك فارغًا يُستخدم الافتراضي.",
  "sms.save": "تحقق واحفظ",
  "sms.checking": "جارٍ التحقق…",
  "sms.saved": "تم التحقق من حساب الرسائل وحفظه.",
  "sms.removed": "تمت إزالة حساب الرسائل.",
  "sms.verified": "تم التحقق",
  "sms.unverified": "لم يتم التحقق",
  "sms.test": "رسالة تجريبية",
  "sms.test.to": "الرقم",
  "sms.test.to.hint": "بالصيغة الدولية، مثل +966…",
  "sms.test.text": "النص",
  "sms.test.send": "إرسال",
  "sms.test.sent": "تم إرسال الرسالة التجريبية.",
  "sms.parts": "{n} رسالة",
  "sms.limits": "الحدود: 3 لكل رقم يوميًا، 2 لكل مكالمة.",
  "sms.log.when": "الوقت",
  "sms.log.to": "الرقم",
  "sms.log.kind": "النوع",
  "sms.log.status": "الحالة",
  "sms.log.text": "النص",
  "sms.kind.test": "تجريبية",
  "sms.kind.summary": "ملخص",
  "sms.kind.link": "رابط",
  "sms.status.sent": "أُرسلت",
  "sms.status.failed": "فشلت",
  "sms.status.refused": "محظورة",
  "error.SMS_NOT_CONFIGURED": "لا يوجد حساب رسائل مرتبط.",
  "error.SMS_AUTH": "اسم المستخدم أو كلمة مرور API غير صحيحة.",
  "error.SMS_BAD_SENDER": "اسم المرسل غير معتمد، أو لا يوجد في حسابك اسم مرسل معتمد بعد. قدّم طلبًا من لوحة المزود؛ يمكن استخدامه بعد الاعتماد.",
  "error.SMS_PASSWORD_REQUIRED": "كلمة مرور API مطلوبة.",
  "error.SMS_NO_CREDIT": "رصيد الرسائل غير كافٍ.",
  "error.SMS_TOO_LONG": "الرسالة طويلة جدًا.",
  "error.SMS_EMPTY": "الرسالة فارغة.",
  "error.SMS_RATE_LIMIT": "المزود مشغول؛ حاول بعد قليل.",
  "error.SMS_NUMBER_DAILY_LIMIT": "تم بلوغ الحد اليومي لهذا الرقم.",
  "error.SMS_CALL_LIMIT": "تم بلوغ حد الرسائل لهذه المكالمة.",
  "error.SMS_DAILY_LIMIT": "تم بلوغ حد الرسائل اليومي.",
  "error.SMS_PROVIDER_ERROR": "رفض مزود الرسائل الطلب.",
  "error.SMS_PROVIDER_DOWN": "تعذر الوصول إلى مزود الرسائل.",
  "wa.title": "واتساب",
  "wa.hint": "الرسائل التي يرسلها الوكيل من المكالمة (ملخص، رابط) تُرسل من حساب واتساب للأعمال الخاص بشركتك بقوالب معتمدة من Meta، فقط إلى رقم المكالمة وعند طلب العميل.",
  "wa.none": "لا يوجد حساب واتساب مرتبط.",
  "wa.connect": "ربط واتساب",
  "wa.where": "تجد هذه البيانات في Meta for Developers ← تطبيقك ← WhatsApp ← API Setup.",
  "wa.phoneNumberId": "معرّف رقم الهاتف",
  "wa.phoneNumberId.hint": "أرقام فقط.",
  "wa.wabaId": "معرّف حساب واتساب للأعمال",
  "wa.wabaId.hint": "أرقام فقط.",
  "wa.token": "رمز الوصول",
  "wa.token.hint": "للرمز الدائم: إعدادات Meta للأعمال ← مستخدمو النظام. الرمز المؤقت ينتهي خلال 24 ساعة.",
  "wa.language": "اللغة",
  "wa.language.hint": "لغة القوالب الافتراضية، مثل tr أو en أو ar.",
  "wa.saved": "تم التحقق من حساب واتساب وحفظه.",
  "wa.removed": "تمت إزالة حساب واتساب.",
  "wa.templates.count": "{n} قالب معتمد (من أصل {all})",
  "wa.templates.unknown": "تعذر جلب القوالب الآن.",
  "wa.template": "القالب",
  "wa.category": "الفئة",
  "wa.template.none": "لا يوجد قالب معتمد؛ أضفه من WhatsApp Manager ← قوالب الرسائل.",
  "wa.params": "القيم",
  "wa.params.hint": "لـ {{1}}، {{2}}… بالترتيب، مفصولة بـ |. اتركها فارغة لقالب بلا متغيرات.",
  "wa.test": "رسالة تجريبية",
  "wa.test.to.hint": "مع الرقم التجريبي تصل فقط إلى المستلمين المسجلين لدى Meta (حتى 5).",
  "wa.test.sent": "تم إرسال رسالة واتساب.",
  "error.WHATSAPP_NOT_CONFIGURED": "لا يوجد حساب واتساب مرتبط.",
  "error.WA_AUTH": "رمز الوصول غير صالح أو منتهي.",
  "error.WA_BAD_ID": "يجب أن تكون المعرفات أرقامًا فقط.",
  "error.WA_TOKEN_REQUIRED": "رمز الوصول مطلوب.",
  "error.WA_RECIPIENT_NOT_ALLOWED": "هذا الرقم غير موجود في قائمة مستلمي الرقم التجريبي (Meta ← API Setup ← To).",
  "error.WA_TEMPLATE_UNKNOWN": "القالب غير موجود.",
  "error.WA_TEMPLATE_NOT_APPROVED": "القالب غير معتمد بهذه اللغة.",
  "error.WA_TEMPLATE_PARAMS": "قيم القالب ناقصة أو زائدة.",
  "error.WA_WINDOW_CLOSED": "النص الحر فقط خلال 24 ساعة من آخر رسالة للعميل؛ استخدم قالبًا.",
  "error.WA_UNDELIVERABLE": "تعذر التسليم إلى هذا الرقم (قد لا يستخدم واتساب).",
  "error.WA_RATE_LIMIT": "تم بلوغ حد الإرسال في واتساب؛ حاول بعد قليل.",
  "error.WA_PROVIDER_ERROR": "رفضت Meta الطلب.",
  "error.WA_PROVIDER_DOWN": "تعذر الوصول إلى Meta.",
  "wa.host.none": "لا يوجد رقم واتساب مرتبط في Panaryus. اربطه مرة واحدة في Panaryus؛ يرسل الوكيل منه وتصل ردود العملاء إلى صندوق وارد Panaryus.",
  "wa.host.connect": "ربط واتساب في Panaryus",
  "wa.host.manage": "الإدارة في Panaryus",
  "wa.host.managed": "رقم مرتبط في Panaryus — تصل الردود إلى صندوق وارد Panaryus.",
  "error.WA_HOST_UNREACHABLE": "تعذر الوصول إلى Panaryus.",
  "error.WHATSAPP_MANAGED_BY_HOST": "تتم إدارة واتساب في Panaryus.",
  "error.PRINCIPAL_NOT_FOUND": "لم يتم العثور على حساب Panaryus.",
  "compliance.title": "الإفصاحات المطلوبة",
  "compliance.item.ai_disclosure": "أوضح أنه ذكاء اصطناعي",
  "compliance.item.recording_notice": "أبلغ بتسجيل المكالمة",
  "compliance.item.business_identity": "ذكر الاسم التجاري المسجل",
  "compliance.late": "بعد المهلة المطلوبة",
  "compliance.missing": "لم يُذكر",
  "error.PERMISSION_DENIED": "ليست لديك صلاحية لهذا الإجراء. اطلبها من مالك الفريق أو المدير.",
  "error.NOT_A_MEMBER": "ليس لديك وصول إلى مساحة العمل هذه.",
  "error.ACCESS_UNAVAILABLE": "تعذر التحقق من صلاحياتك الآن؛ حاول بعد قليل.",
  "error.ROUTE_NOT_CLASSIFIED": "هذا الإجراء معطل حاليًا.",
  "error.VOICE_TURKISH_ONLY": "هذا الصوت يتحدث التركية فقط؛ لغة هذا الوكيل مختلفة.",
  "access.readOnly": "للعرض فقط. التعديل يحتاج صلاحية «{name}»؛ اطلبها من مالك الفريق أو المدير.",
  "access.noPage": "ليس لديك وصول إلى هذه الصفحة. تحتاج صلاحية «{name}»؛ اطلبها من مالك الفريق أو المدير.",
  "access.perm.centeros.view": "عرض المكالمات والإحصاءات",
  "access.perm.centeros.recordings": "التسجيلات والنصوص الكاملة",
  "access.perm.centeros.call": "المكالمات وغرفة الاختبار",
  "access.perm.centeros.contacts": "جهات الاتصال وقائمة عدم الاتصال",
  "access.perm.centeros.campaigns": "الحملات",
  "access.perm.centeros.agents": "الوكلاء (إنشاء وتعديل ونشر)",
  "access.perm.centeros.lines": "خطوط الهاتف والرسائل",
  "access.perm.centeros.compliance": "الخصوصية وسجل النشاط",
  "nav.audit": "سجل النشاط",
  "audit.title": "سجل النشاط",
  "audit.subtitle": "من فعل ماذا ومتى في اللوحة: التغييرات والتسجيلات المسموعة والمحاولات المرفوضة. لا يُحفظ المحتوى؛ ولا يمكن حذف السجلات.",
  "audit.empty": "لا توجد سجلات بعد.",
  "audit.when": "الوقت",
  "audit.who": "من",
  "audit.what": "الإجراء",
  "audit.on": "الهدف",
  "audit.result": "النتيجة",
  "audit.more": "الأقدم",
  "audit.res.ok": "تم",
  "audit.res.denied": "غير مسموح",
  "audit.res.failed": "خطأ",
  "audit.verb.POST": "إضافة/إجراء",
  "audit.verb.PUT": "تعديل",
  "audit.verb.PATCH": "تعديل",
  "audit.verb.DELETE": "حذف",
  "audit.verb.GET": "عرض",
  "audit.area.agents": "الوكيل",
  "audit.area.calls": "المكالمة",
  "audit.area.contacts": "جهات الاتصال",
  "audit.area.do-not-call": "قائمة عدم الاتصال",
  "audit.area.campaigns": "الحملة",
  "audit.area.telephony": "خط الهاتف",
  "audit.area.sms": "حساب الرسائل",
  "audit.area.whatsapp": "واتساب",
  "audit.area.templates": "القالب",
  "audit.area.studio": "الاستوديو",
  "audit.area.test-rooms": "غرفة الاختبار",
  "audit.area.previews": "المعاينة",
  "audit.action.POST /v2/api/agents/:id/publish": "تم نشر الوكيل",
  "audit.action.PUT /v2/api/agents/:id/spec": "تغيرت إعدادات الوكيل",
  "audit.action.POST /v2/api/agents/:id/calls": "بدأت مكالمة",
  "audit.action.POST /v2/api/agents/:id/web-calls": "مكالمة من المتصفح",
  "audit.action.GET /v2/api/calls/:id/recording": "تم الاستماع إلى تسجيل",
  "audit.action.POST /v2/api/do-not-call": "أضيف إلى قائمة عدم الاتصال",
  "audit.action.DELETE /v2/api/do-not-call/:e164": "أزيل من قائمة عدم الاتصال",
  "audit.action.POST /v2/api/contacts/import": "تم استيراد جهات الاتصال",
  "audit.action.DELETE /v2/api/contacts/:id": "حُذفت جهة اتصال",
  "audit.action.POST /v2/api/campaigns": "أنشئت حملة",
  "audit.action.POST /v2/api/campaigns/:id/:action": "بدأت/توقفت حملة",
  "audit.action.POST /v2/api/test-rooms": "مكالمة غرفة الاختبار",
  "nav.privacy": "البيانات والخصوصية",
  "privacy.title": "البيانات والخصوصية",
  "privacy.subtitle": "مدة الاحتفاظ بالبيانات الشخصية للمكالمات. يُحذف ما انتهت مدته تلقائيًا كل ليلة.",
  "privacy.retention": "مدد الاحتفاظ",
  "privacy.retention.hint": "كل منها {min}–{max} يومًا. لا ينبغي الاحتفاظ بالبيانات الشخصية أطول من اللازم؛ حددها مع مستشارك القانوني.",
  "privacy.recordings": "تسجيلات المكالمات (أيام)",
  "privacy.recordings.hint": "الموصى به: {n} يومًا. يُحذف التسجيل المنتهي من التخزين.",
  "privacy.transcripts": "النصوص والملخصات (أيام)",
  "privacy.transcripts.hint": "الموصى به: {n} يومًا. تُحذف النصوص والملخص والمعلومات المجمعة وكلام العميل.",
  "privacy.messages": "الرسائل المرسلة (أيام)",
  "privacy.messages.hint": "الموصى به: {n} يومًا. تُحذف نصوص الرسائل وواتساب.",
  "privacy.kept": "يبقى: تاريخ المكالمة ومدتها وتقييمها ونتيجتها وتوقيت الإفصاحات والتكلفة — تبقى الإحصاءات سليمة. لا تُحذف قائمة عدم الاتصال.",
  "privacy.save": "حفظ",
  "privacy.saved": "تم حفظ مدد الاحتفاظ.",
  "privacy.updated": "آخر تعديل: {at}",
  "privacy.usingDefaults": "تُستخدم المدد الموصى بها.",
  "privacy.callPurged": "حُذف تسجيل و/أو نص هذه المكالمة في {at} (انتهاء مدة الاحتفاظ).",
  "privacy.erase.title": "طلب حذف البيانات الشخصية",
  "privacy.erase.hint": "عندما يطلب شخص حذف بياناته: تُحذف تسجيلات ذلك الرقم؛ وتُمحى النصوص والملخصات والرسائل والاسم/الرقم في قوائم الحملات؛ وتُزال جهة الاتصال. يقتصر على مساحة العمل هذه.",
  "privacy.erase.phone": "رقم الهاتف",
  "privacy.erase.dnc": "أضف إلى قائمة عدم الاتصال حتى لا يُتصل به مرة أخرى (يُحتفظ بالرقم فقط)",
  "privacy.erase.button": "حذف البيانات نهائيًا",
  "privacy.erase.warn": "لا يمكن التراجع. يُسجَّل في سجل النشاط.",
  "privacy.erase.done": "تم الحذف: {calls} مكالمة، {recordings} تسجيل، {messages} رسالة، {contacts} جهة اتصال.",
  "privacy.iys.title": "التحقق من سجل الموافقات (İYS)",
  "privacy.iys.hint": "قبل أي مكالمة تجارية يُسأل سجل الموافقات التركي (İYS) عن موافقة الرقم. يُحفظ الرد بضعة أيام، ولا يُعاد الاستعلام عن الرقم نفسه خلالها. الرقم بلا موافقة لا يُتصل به (يظهر في تقرير الحملة \"لا توجد موافقة في İYS\"). عندما يطلب شخص عدم الاتصال به يُلغى الرد المحفوظ لرقمه. الوكلاء ذوو الغرض الإعلامي لا يُتحقق منهم.",
  "privacy.iys.enabled": "اسأل İYS عن الموافقة قبل المكالمة التجارية",
  "privacy.iys.days": "مدة حفظ الرد (أيام)",
  "privacy.iys.days.hint": "من 0 إلى 30 يومًا، والموصى به 7. القيمة 0 = يُسأل من جديد في كل مكالمة.",
  "privacy.iys.skipBusiness": "تخطَّ استعلام İYS للأرقام المعلَّمة \"منشأة\" في جهات الاتصال",
  "privacy.iys.skipBusiness.hint": "تستند هذه القاعدة إلى معلومات عامة وتنتظر تأكيد محامٍ، لذا يمكن إيقافها. عند إيقافها يُستعلم عن أرقام المنشآت أيضًا (كتجّار). الأرقام المعلَّمة \"غير معروف\" يُستعلم عنها كأرقام أفراد.",
  "privacy.iys.noProvider": "لم يُربط مزوّد İYS بعد، لذا لا يمكن تفعيل التحقق. بعد الربط تكلفة الاستعلام الواحد {price} ليرة تركية.",
  "privacy.iys.mock": "مزوّد تجريبي مربوط: الردود مصطنعة ومجانية، ولا يُسأل İYS فعليًا.",
  "privacy.iys.provider": "المزوّد: {name} · {price} ليرة تركية لكل استعلام",
  "privacy.iys.stats": "هذا الشهر ({month})",
  "privacy.iys.stats.queries": "الاستعلامات المرسلة",
  "privacy.iys.stats.cached": "أُجيب من رد محفوظ",
  "privacy.iys.stats.business": "أرقام منشآت (بلا استعلام)",
  "privacy.iys.stats.spent": "المصروف",
  "privacy.iys.money": "{amount} ليرة تركية",
  "privacy.iys.defaults": "الإعدادات الافتراضية: التحقق متوقف، 7 أيام، تخطي أرقام المنشآت.",
  "privacy.iys.saved": "تم حفظ إعدادات İYS.",
  "settings.legal": "المعلومات القانونية",
  "settings.legal.hint": "هوية الجهة المتصلة وسبب الاتصال في المكالمات التجارية.",
  "field.identity.legalName": "الاسم التجاري المسجل",
  "field.identity.legalName.hint": "إذا أُدخل، يجب أن يذكره الوكيل في بداية المكالمة، ويظهر الدليل في بطاقة المكالمة.",
  "field.callPurpose": "غرض المكالمات",
  "field.callPurpose.hint": "في المكالمات التجارية تُفحص الموافقة في سجل الموافقات قبل الاتصال إن كان مربوطًا.",
  "field.callPurpose.commercial": "تجاري (ترويج، مبيعات)",
  "field.callPurpose.informational": "إعلامي (موعد، تذكير، معاملة)",
  "settings.consent.notConnected": "سجل الموافقات غير مربوط بعد: لا تُفحص المكالمات التجارية. تحقق من الموافقة بنفسك قبل الاتصال بالأفراد لأغراض تجارية.",
  "error.CONSENT_REFUSED": "هذا الرقم لا يوافق على المكالمات التجارية.",
  "error.CONSENT_UNKNOWN": "موافقة هذا الرقم غير معروفة؛ لم يتم الاتصال وفق الإعدادات.",
  "error.IYS_NO_CONSENT": "لا توجد موافقة في İYS",
  "error.IYS_PROVIDER_MISSING": "لا يوجد مزوّد İYS مربوط.",
  "error.IYS_CHECK_FAILED": "تعذّر إجراء استعلام İYS.",
  "error.BACKUP_VOICE_UNKNOWN": "هذا الصوت الاحتياطي غير متاح؛ اختر صوتًا من القائمة.",
  "error.CALL_HAS_NO_NUMBER": "لا يوجد في هذه المكالمة رقم هاتف يمكن حفظه.",
  "error.HOURS_INVALID": "ساعات العمل غير صالحة.",
  "error.INBOUND_AGENT_REQUIRED": "اختر أولًا الوكيل الذي يجيب على هذا الرقم.",
  "error.CLOSED_MESSAGE_FAILED": "تعذّر تحويل الرسالة إلى صوت؛ احفظ مرة أخرى بعد قليل.",
  "calls.tab.web": "محادثات الموقع",
  "web.empty": "لا توجد محادثات على الموقع بعد. ستظهر محادثات الزوار هنا بعد إضافة الأداة إلى موقعك.",
  "web.pick": "اختر محادثة.",
  "web.messages": "{n} رسائل",
  "web.collected": "ما جمعه الوكيل",
  "web.request": "موضوع أُحيل إلى الفريق",
  "web.page": "آخر صفحة",
  "web.ended": "انتهت",
  "web.open": "مفتوحة",
  "web.visitor": "الزائر",
  "web.agent": "الوكيل",
  "web.noFacts": "لم تُجمع معلومات بعد.",
  "web.site": "الموقع",
  "calls.party.webChat": "محادثة الموقع",
  "web.report": "تقرير المحادثة",
  "web.report.none": "بدأت هذه المحادثة قبل ميزة التقارير؛ لا تقرير لها.",
  "web.report.pending": "يجري إعداد التقرير (خلال دقيقة بعد انتهاء المحادثة).",
  "web.report.afterEnd": "يُعدّ التقرير عند انتهاء المحادثة (عندما ينهيها الزائر أو بعد ساعتين من عدم النشاط).",
  "web.openCall": "افتح بطاقة المحادثة (التكلفة، التقييم)"
}
